import { ChangeDetectorRef, Component, ViewChild } from '@angular/core';
import { ApiService } from '../services/contratos/contratos.service';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Observable, Subscription, map, of, interval, firstValueFrom, catchError } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { AutenticacaoService } from '../autenticacao/autenticacao.service';
import { UsuarioLogado } from '../autenticacao/usuario-logado.type';
import { Router } from '@angular/router';
import { DatePipe } from '@angular/common';
import * as ExcelJS from 'exceljs';
import * as fs from 'file-saver'; // Importe a biblioteca file-saver
import { Location } from '../../app/interfaces';
import { format, parseISO } from 'date-fns';
import { lastValueFrom } from 'rxjs';
import { SlotRecebimento, volumesPorHora } from '../shared/volumesHora';

interface ItemTimeTable {
  ID: string;
  Janela: string;
  Plate: string;
  Volumes: number | string;
  idContainer?: string;
  Transportadora: string;
  Fornecedores: string;
  tableName: string;
  Area: string;
  Sequencia: string;
}

interface SlotsRecebimento {
  slotRecsider: number,
  slotEmbMR: number,
  slotEmb: number,
  slotInt: number,
  slotExp: number,
  slotReccontainer: number,
  slotRecsiderReduzido: number,
  slotEmbMRReduzido: number,
  slotEmbReduzido: number,
  slotIntReduzido: number,
  slotExpReduzido: number,
  slotReccontainerReduzido: number,
  tableName: string,
  UpdateByUser: string,
  lastUpdate: string,
  ID: string,
  horarioAlmoco: string,
  horarioJanta: string,
  horarioTrocaTurno: string,
}

@Component({
  selector: 'app-time-table-interplantas',
  templateUrl: './time-table-interplantas.component.html',
  styleUrls: ['./time-table-interplantas.component.css'],
  standalone: false
})
export class TimeTableInterplantasComponent {
  argentina!: any[];
  item: any = {
    ID: '',
    local: '',
    contato: '',
    endereco: '',
    latitude: '',
    longitude: '',
    descarga: false
  };
  urlAtualiza: string = 'https://uj88w4ga9i.execute-api.sa-east-1.amazonaws.com/dev12';
  urlConsultaCompactada: string = 'https://q9hhz5wjah.execute-api.sa-east-1.amazonaws.com/volumeGD';
  urlConsulta: string = 'https://fopq9ohj7e.execute-api.sa-east-1.amazonaws.com/v1';
  urlConsultaTrips: string = 'https://qu0d5gqb4g.execute-api.sa-east-1.amazonaws.com/v1/';
  urlLimpaTabelaPrevisao: string = 'https://9wnzipa996.execute-api.sa-east-1.amazonaws.com/v1/GET';
  tableNameLocation: string = 'Fornecedores_Karrara_Transport';
  query: string = 'Itens_Jetta';
  tabelaPrevisao: string = 'previsaoVolumeLCB';
  query2: string = 'Carriers';
  queryVeiculosLab: string = 'veiculos_lab_Karrara'
  query3: string = 'tipos_Veiculos_Karrara';
  query4: string = 'items_Excel_Karrara';
  queryVW: string = 'items_Operacao_VW';
  queryInterplantas: string = 'Operacao_Interplantas_Karrara';
  queryTimeTable: string = 'janelasTimeTable';
  queryChegadasLCB: string = 'ChegadasNoLCB';
  queryDiretasExtrasLCB: string = "Viagens-LCB-Diretas-Extras";
  queryDiretasLCB: string = "Viagens-Diretas-Planilha";
  data: any;
  base: number = 3;
  ID: number = Date.now();
  local: string = "";
  contato: string = "";
  endereco: string = "";
  comentario: string = "";
  dialogRef: any;
  items: any[] = [];
  totalMR: any[] = [];
  totalMRSemArg: any[] = [];
  itemsSP: any[] = [];
  itemsSul: any[] = [];
  itemsArg: any[] = [];
  itemsInterplantas: any[] = [];
  itemsInterplantasNaoFinalizados: any[] = [];
  itemsSPFinalizados: any[] = [];
  itemsSulFinalizados: any[] = [];
  itemsArgNaoFinalizados: any[] = [];
  totalMRFinalizado: any[] = [];
  name!: string;
  dialogOpen = false;
  dialogTiposOpen = false;
  carrier!: any[];
  veiculos!: any[];
  teste!: boolean;
  startDate!: string;
  endDate!: string;
  milkRunSP: boolean = true;
  milkRunSul: boolean = true;
  milkRunArg: boolean = true;
  filteredItems!: any[];
  interplantas: any[] = [];
  filteredInterplantas: any[] = [];
  naoTerminadas: any[] = [];
  distanciaTotal: number = 0;
  pesoTotal: number = 0;
  pesoTotalInterplantas: number = 0;
  usuarioLogado!: UsuarioLogado;
  isCarrierTCMEnabled: boolean = true;
  isCarrierJSLEnabled: boolean = true;
  isCarrierJSLVWEnabled: boolean = true;
  isCarrierLOTSEnabled: boolean = true;
  isCarrierJSLARGEnabled: boolean = true;
  redistribuirAutomatica: boolean = false;
  isCarrierEnabled: boolean = true;
  subscription: Subscription | undefined;
  hoje = new Date();
  dataFiltra2Dias!: string;
  dataFiltraInterplantas!: string;
  dataFiltraSul!: string;
  dataFiltraArg!: string;
  objFillingRate: number = 85;
  classFillingRate: string = "";
  objVeiculosGrandes: number = 90;
  classVeiculosGrandes: string = "";
  objJanelas: number = 90;
  classJanelas: string = "";
  objMR!: number;
  classMR: string = "";
  objInterplantas!: number;
  classInterplantas: string = "";
  viagensInterplantasFinalizadas!: any[];
  localNumber!: number;
  propertyName!: string;
  viagensInterplantasTerminadas!: any[];
  viagensInterplantasTerminadasNumero!: number;
  pesoTotalTransportadoMR!: number;
  valorTotalTransportadoMR: number = 0;
  totalCostMR!: number;
  MRtotalizado!: number;
  qtdVeiculosGD!: number;
  totalEmissao!: number;
  tolerancia: number = 0.1; // 10%
  eficiencia!: number;
  porcentagemPontual!: number;
  porcentagemAtrasado!: number;
  porcentagemTotal!: number;
  classJanelasPontual!: string;
  classJanelasAtrasada!: string;
  classJanelasTotal!: string;
  totalMRDeveriaFinalizar!: number;
  totalJanelasInterplantasObj!: number;
  searchText: string = 'All';
  viagensInterplantasNaoTerminadas!: any[];
  filterColumnDados: string = 'dataPainel';
  filterColumnOperacao: string = 'Janela';
  referenceDate!: string;
  numDays: number = 2;
  numDays5: number = 5;
  porcentagemPontualColeta!: number;
  porcentagemPontualEntrega!: number;
  porcentagemColetaPontual!: number;
  porcentagemColetaAtrasado!: number;
  porcentagemColetaTotal!: number;
  porcentagemEntregaPontual!: number;
  porcentagemEntregaAtrasado!: number;
  porcentagemEntregaTotal!: number;
  classJanelasColeta!: string;
  classJanelasEntrega!: string;
  valorUmColeta!: number;
  valorDoisColeta!: number;
  valorUmEntrega!: number;
  valorDoisEntrega!: number;
  totalJanelasValidasColeta!: number;
  totalJanelasValidasEntrega!: number;
  altura: number = 10;
  largura: number = 10;
  labels = ["02:00", "Realizadas", "Planejadas"];
  sortColumn: string = '';
  mergedData: any[] = []; // Definir explicitamente o tipo como any[]
  sortDirection: number = 1;
  RECCONT: boolean = true;
  EXP: boolean = false;
  INT: boolean = false;
  EMB: boolean = false;
  RECSIDER: boolean = true;
  timeTableExcesso: any[] = [];
  corJanela: string = '';
  atrasado: boolean = false;
  editMode = false;
  editedValue: any;
  filterColumn: string = 'date';
  editJanelaDestino1!: string;
  editJanelaDestino2!: string;
  editJanelaDestino3!: string;
  editJanelaDestino4!: string;
  itemSelecionado: any;
  dataExibirPre: Date = new Date();
  dataExibir: Date = new Date();
  ultimoEstouroPorAreaEmpurra: { [area: string]: number } = {};
  ultimoEstouroPorArea: { [area: string]: number } = {};

  timeTable00 = this.createPlacaData();
  timeTable01 = this.createPlacaData();
  timeTable02 = this.createPlacaData();
  timeTable03 = this.createPlacaData();
  timeTable04 = this.createPlacaData();
  timeTable05 = this.createPlacaData();
  timeTable06 = this.createPlacaData();
  timeTable07 = this.createPlacaData();
  timeTable08 = this.createPlacaData();
  timeTable09 = this.createPlacaData();
  timeTable10 = this.createPlacaData();
  timeTable11 = this.createPlacaData();
  timeTable12 = this.createPlacaData();
  timeTable13 = this.createPlacaData();
  timeTable14 = this.createPlacaData();
  timeTable15 = this.createPlacaData();
  timeTable16 = this.createPlacaData();
  timeTable17 = this.createPlacaData();
  timeTable18 = this.createPlacaData();
  timeTable19 = this.createPlacaData();
  timeTable20 = this.createPlacaData();
  timeTable21 = this.createPlacaData();
  timeTable22 = this.createPlacaData();
  timeTable23 = this.createPlacaData();
  timeTable24 = this.createPlacaData();

  timeTableGeral: { [key: string]: any[] }[] = [this.timeTable00, this.timeTable01, this.timeTable02, this.timeTable03, this.timeTable04, this.timeTable05,
  this.timeTable06, this.timeTable07, this.timeTable08, this.timeTable09, this.timeTable10, this.timeTable11, this.timeTable12, this.timeTable13, this.timeTable14, this.timeTable15
    , this.timeTable16, this.timeTable17, this.timeTable18, this.timeTable19, this.timeTable20, this.timeTable21, this.timeTable22, this.timeTable23, this.timeTable24];


  itemsVW!: any[];
  itemsVWNaoFinalizados!: any[];
  isLoading: boolean = false;
  telaCarregada: boolean = false;
  itemsSPFinalizados2!: any[];
  janelaDestino: any;
  fornecedores!: any[];
  numDays15: number = 10;
  edit2: boolean = false;
  totalReservas!: any[];
  itemsReserva!: any[];
  classHora!: any[];
  totalItensJetta!: any[];
  totalReservasRECCONT!: any[];
  totalReservasRECSIDER!: any[];
  itemsChegadaLCB!: any[];
  objetosCorrespondentes!: any[];
  itemsContainers!: any[];
  atrasadoContainer: boolean = false;
  atrasadoRECSIDER: boolean = false;
  totalReservasEMB!: any[];
  totalReservasEMBMR!: any[];
  atrasadoEMB!: boolean;
  itemsContainersReuse!: any[];
  itemsMRColetaEmbalagem!: any[];
  totalReservasEXP!: any[];
  atrasadoEXP!: boolean;
  volumesTotais: any;
  valorItemVolume: number[][] = new Array(25).fill([]).map(() => new Array(5).fill(0));
  itemsContainersPrev!: any[];
  array1Filtrado: any;
  array2Filtrado: any;
  locais!: any[];
  veiculosLab: any;
  locaisName!: any[];
  ataulPlate: any;
  atualPlate: any;
  filtroacionado: boolean = false;
  totalCont: any[] = [];
  dataJanelaDestino2Alterada!: string;
  horaJanelaDestino2Alterada!: string;
  dataJanelaDestino3Alterada: any;
  horaJanelaDestino3Alterada: any;
  campoTocado: boolean = false;
  opcoesMotivo = [
    { valor: 0, descricao: "-" },
    { valor: 1, descricao: "Atraso no transporte/Transportadora" },
    { valor: 2, descricao: "Atraso no fornecedor" },
    { valor: 3, descricao: "Atraso no recebimento/SCANIA" },
    { valor: 4, descricao: "Atraso no recebimento/LCB" },
    { valor: 5, descricao: "Excesso de veículos no mesmo horário" },
    { valor: 6, descricao: "Chegada antecipada" },
    { valor: 10, descricao: "Realocação automática" },
    { valor: 99, descricao: "Teste" }
  ];
  timeTableExcessoFiltrados!: any[];
  EMBMR: any;
  showEMB!: boolean;
  ViagensLCBDiretasExtras!: any[];
  itemTimeTable !: ItemTimeTable[];
  ADMEnabled: boolean = true;
  slotsRecebimentos: SlotsRecebimento = {
    slotRecsider: 3,
    slotEmbMR: 4,
    slotEmb: 1,
    slotInt: 4,
    slotExp: 4,
    slotReccontainer: 3,
    slotRecsiderReduzido: 1,
    slotEmbMRReduzido: 1,
    slotEmbReduzido: 1,
    slotIntReduzido: 1,
    slotExpReduzido: 1,
    slotReccontainerReduzido: 1,
    tableName: 'slotsRecebimentos',
    UpdateByUser: '',
    lastUpdate: '',
    ID: '1',
    horarioAlmoco: '0',
    horarioJanta: '5',
    horarioTrocaTurno: '15'
  }
  limiteVolumes: { [area: string]: { [hora: number]: number } } = {};
  dialogOpenSlots: boolean = false;
  dialogOpenVolumes: boolean = false;
  querySlotsReceb: string = 'slotsRecebimentos';
  slots: SlotsRecebimento = this.slotsRecebimentos;

  slotLimits: { [hora: number]: { [area: string]: number } } = {};
  slotLimitsCriacaoHTML: { [area: string]: number } = {};
  areaSlotCounts: { [area: string]: number } = {};
  volumesHoraRecsider: number[] = [];
  volumesHoraRecCont: number[] = [];
  volumesHoraInt: number[] = [];
  volumesHoraEmb: number[] = [];
  volumesHoraEmbMR: number[] = [];
  volumesHoraExp: number[] = [];
  horas = Array.from({ length: 24 }, (_, i) => i);
  novoTotal: any;
  limiteVolumePorHora: { [hora: string]: { [area: string]: number } } = {};
  VolumeAtualPorHoraEmpurra: { [hora: string]: { [area: string]: number } } = {};
  VolumeAtualPorHora: { [hora: string]: { [area: string]: number } } = {};
  VolumeSobraPorHora: { [hora: string]: { [area: string]: number } } = {};
  volumeAtualMaisVolVeiculo: number = 0;
  horasEstouradas: { [hora: string]: { [area: string]: boolean } } = {};
  overflowTable: { [area: string]: any[] } = {};
  itemsMontarTimeTable: any[] = [];

  constructor(
    public dialog: MatDialog,
    private dynamodbService: ApiService,
    private http: HttpClient, private cdr: ChangeDetectorRef,
    private servicoAutenticacao: AutenticacaoService,
    private router: Router,
    private datePipe: DatePipe
  ) {
    this.volumesTotais = {};
    this.itemsMRColetaEmbalagem = [];
  }

  async ngOnInit() {
    this.isLoading = true;
    this.itemTimeTable = [];
    try {
      const today = new Date();
      const year = today.getFullYear();
      const month = (today.getMonth() + 1).toString().padStart(2, '0');
      const day = today.getDate().toString().padStart(2, '0');
      this.endDate = `${year}-${month}-${day}`;
      this.startDate = `${year}-${month}-${day}`;

      const sevenDaysAgo = new Date(today);
      sevenDaysAgo.setDate(today.getDate() - 10);
      const sevenDaysAgoYear = sevenDaysAgo.getFullYear();
      const sevenDaysAgoMonth = (sevenDaysAgo.getMonth() + 1).toString().padStart(2, '0');
      const sevenDaysAgoDay = sevenDaysAgo.getDate().toString().padStart(2, '0');
      this.dataFiltraArg = `${sevenDaysAgoYear}-${sevenDaysAgoMonth}-${sevenDaysAgoDay}`;

      const twoDaysAgo = new Date(today);
      twoDaysAgo.setDate(today.getDate() - 1);
      const twoDaysAgoYear = twoDaysAgo.getFullYear();
      const twoDaysAgoMonth = (twoDaysAgo.getMonth() + 1).toString().padStart(2, '0');
      const twoDaysAgoDay = twoDaysAgo.getDate().toString().padStart(2, '0');
      this.dataFiltra2Dias = `${twoDaysAgoYear}-${twoDaysAgoMonth}-${twoDaysAgoDay}`;

      const threeDaysAgo = new Date(today);
      threeDaysAgo.setDate(today.getDate() - 3);
      const threeDaysAgoYear = threeDaysAgo.getFullYear();
      const threeDaysAgoMonth = (threeDaysAgo.getMonth() + 1).toString().padStart(2, '0');
      const threeDaysAgoDay = threeDaysAgo.getDate().toString().padStart(2, '0');
      this.dataFiltraSul = `${threeDaysAgoYear}-${threeDaysAgoMonth}-${threeDaysAgoDay}`;

      const diaAtual = new Date(today);
      diaAtual.setDate(today.getDate());
      const diaAtualYear = diaAtual.getFullYear();
      const diaAtualMonth = (diaAtual.getMonth() + 1).toString().padStart(2, '0');
      const diaAtualDay = diaAtual.getDate().toString().padStart(2, '0');
      this.dataFiltraInterplantas = `${diaAtualYear}-${diaAtualMonth}-${diaAtualDay}`;

      await this.getLocais();
      await this.getVeiculosLab();
      await this.getCarriersFromDynamoDB();
      await this.getUserLogado();
      await this.update();
      this.centerDialog();
      this.subscription = interval(3 * 60 * 1000).subscribe(async () => {
        await this.update();
      });
    } catch (error) {
      console.error('Erro durante a execução do ngOnInit:', error);
    }
  }

  async update() {
    this.itemTimeTable = [];
    const areas = ["EXP", "RECSIDER", "RECCONT", "EMB", "EMBMR", "INT"];
    for (const area of areas) {
      this.overflowTable[area] = [];
    }
    await this.getSlots();
    await this.getVolumesSlots();
    // await this.getItemsTabelaTimeTable();
    await this.getItemsContainer();
    await this.getItemsFromArgentina();
    await this.getItemsFromDynamoDB();
    await this.getItemsFromJanelasReservadas();
    await this.getItemsFromVW();
    await this.getProgramacaoInterplantasFromDynamoDB();
    this.totalReservasRECCONT = await this.removeDuplicados(this.totalReservasRECCONT, this.itemsContainers);
    await this.somarFluxosFinalizado();
    // if (this.redistribuirAutomatica) await this.somarFluxosFinalizado();
    // await this.atualizarStatusTimeTableNoBanco(this.itemsVW);
    // await this.atualizarStatusTimeTableNoBanco(this.itemsArg);
    // await this.atualizarStatusTimeTableNoBanco(this.itemsInterplantas);
    // await this.atualizarStatusTimeTableNoBanco(this.totalReservas);
    // await this.atualizarStatusTimeTableNoBanco(this.totalItensJetta);
    // await this.atualizarStatusTimeTableNoBanco(this.itemsContainers);
    // await this.salvarStatusAtualizado(this.itemsMontarTimeTable)
    // await this.atualizaStatus(this.itemsMontarTimeTable)
    // this.timeTableGeral = this.reconstruirTimeTableGeral(this.itemsMontarTimeTable);
    await this.somarVolumes();
    this.isLoading = false;
    this.telaCarregada = true;
  }

  getArray(count: number): number[] {
    return Array.from({ length: count }, (_, i) => i);
  }

  get opcoesMotivoFiltradas() {
    return this.usuarioLogado.role === '9' ? this.opcoesMotivo : this.opcoesMotivo.filter(o => o.valor !== 10 && o.valor !== 99);
  }

  editSlot() {
    this.slots = this.slotsRecebimentos;
    this.dialogOpenSlots = true;
  }

  editVolumes() {
    // this.volumesHora = this.slotsRecebimentos;
    this.dialogOpenVolumes = true;
  }

  async atualizaData() {
    const areas = ["EXP", "RECSIDER", "RECCONT", "EMB", "EMBMR", "INT"];
    for (const area of areas) {
      // 🔹 Inicializa os objetos/arrays antes de usar
      if (!this.limiteVolumes) this.limiteVolumes = {};
      if (!this.VolumeSobraPorHora) this.VolumeSobraPorHora = {};
      if (!this.VolumeAtualPorHora) this.VolumeAtualPorHora = {};
      this.limiteVolumes[area] = [];
      this.VolumeSobraPorHora[area] = {};
      this.VolumeAtualPorHora[area] = {};
      for (let horaSlot = 0; horaSlot < 24; horaSlot++) {
        this.limiteVolumes[area][horaSlot] = 0
        this.VolumeSobraPorHora[area][horaSlot] = 0;
      }
      this.VolumeAtualPorHora[area] = {};
    }
    this.filtroacionado = true;
    this.isLoading = true;
    this.dataExibir = this.dataExibirPre;
    let novaDataExibir = new Date(this.dataExibir);
    // Adicionar 3 horas à nova data
    novaDataExibir.setHours(novaDataExibir.getHours() + 3);
    // Atualizar this.dataExibir para a nova data
    this.dataExibir = novaDataExibir;
    await this.update();
    this.isLoading = false;
  }

  createPlacaData(): { [key: string]: any[] } {
    return {
      RECCONT: [],
      EMB: [],
      EMBMR: [],
      EXP: [],
      INT: [],
      RECSIDER: [],
    };
  }

  async getVolumesSlots(): Promise<void> {
    try {
      const response: any = await lastValueFrom(
        this.dynamodbService.getItems("slotsRecebimentosVolumes", this.urlConsulta, "")
      );
      if (response.statusCode === 200) {
        const items = JSON.parse(response.body);
        const desserializados = items.map((item: any) => {
          const novoItem: any = { ...item };
          const areas = ["EXP", "RECSIDER", "RECCONT", "EMB", "EMBMR", "INT"];

          for (const area of areas) {
            if (novoItem[area]) {
              try {
                // se vier string, parse; se vier objeto, mantém
                const parsed =
                  typeof novoItem[area] === "string"
                    ? JSON.parse(novoItem[area])
                    : novoItem[area];
                novoItem[area] = parsed;
                // 🔹 agora converte para array e salva direto nas variáveis
                const arr: number[] = Array(24).fill(100);
                for (let h = 0; h < 24; h++) {
                  arr[h] = parsed[h.toString()];
                }
                // console.log(arr)
                switch (area) {
                  case "EXP":
                    this.volumesHoraExp = arr;
                    break;
                  case "RECSIDER":
                    this.volumesHoraRecsider = arr;
                    break;
                  case "RECCONT":
                    this.volumesHoraRecCont = arr;
                    break;
                  case "EMB":
                    this.volumesHoraEmb = arr;
                    break;
                  case "EMBMR":
                    this.volumesHoraEmbMR = arr;
                    break;
                  case "INT":
                    this.volumesHoraInt = arr;
                    break;
                }
              } catch (e) {
                console.warn(`Erro ao parsear ${area}:`, e, novoItem[area]);
              }
            }
          }
          return novoItem;
        });
        this.buildSlotLimitsVolume(desserializados);
      } else {
        console.error("Invalid response:", response);
      }
    } catch (error) {
      console.error("Erro no getSlots:", error);
    }
  }

  buildSlotLimitsVolume(slots: any[]) {
    this.limiteVolumes = {};
    for (const slot of slots) {
      const areas = ["EXP", "RECSIDER", "RECCONT", "EMB", "EMBMR", "INT"];
      for (const area of areas) {
        const horarios = slot[area]; // objeto { "0": 60, "1": 70, ... }
        if (!horarios) continue;
        if (!this.limiteVolumes[area]) {
          this.limiteVolumes[area] = {};
        }
        for (const [hora, volume] of Object.entries(horarios)) {
          const horaNum = parseInt(hora, 10);
          this.limiteVolumes[area][horaNum] = volume as number;
        }
      }
    }
    // console.log('limiteVolumes')
    // console.log(this.limiteVolumes)
  }

  getSlotLimit(hora: number, area: string): number {
    return this.slotLimits[hora]?.[area] ?? 0;
  }

  getVolumePorHora(hora: number, area: string): number {
    return this.limiteVolumePorHora[hora]?.[area] ?? 0;
  }

  getSlotLimitArea(area: string): number {
    return this.slotLimitsCriacaoHTML[area] ?? 0;
  }

  async salvarAlteracaoDiaSeguinte(item: any) {
    const dataOriginal = new Date(item.dataHoraJanela || item.dataAlteradaLCB);
    const ano = dataOriginal.getFullYear();
    const mes = dataOriginal.getMonth();
    const dia = dataOriginal.getDate();
    const novaData = new Date(ano, mes, dia + 1, 0, 0, 0);
    const novaDataFormatada = novaData.toISOString().split("T")[0]; // "2025-07-29"
    const itemAtualizado = {
      ...item,
      lastUpdate: new Date(),
      UpdateByUser: "realocação",
      dataAlteradaLCB: novaDataFormatada,
      horaAlteradaLCB: "00:00",
      motAlteracao: 10,
      overflow: false,
      // dataJanelaDestino1Alterada: item['Destino 1'] && item['Destino 1'].includes('LCB') ? item['JanelaDestino1Alterada'] = `${item['dataAlteradaLCB']}T${item['horaAlteradaLCB']}:00.000Z` :
      //   item['Destino 2'] && item['Destino 2'].includes('LCB') ? item['JanelaDestino2Alterada'] = `${item['dataAlteradaLCB']}T${item['horaAlteradaLCB']}:00.000Z` :
      //     item['Destino 3'] && item['Destino 3'].includes('LCB') ? item['JanelaDestino3Alterada'] = `${item['dataAlteradaLCB']}T${item['horaAlteradaLCB']}:00.000Z` :
      //       item['Destino 4'] && item['Destino 4'].includes('LCB') ? item['JanelaDestino4Alterada'] = `${item['dataAlteradaLCB']}T${item['horaAlteradaLCB']}:00.000Z` : undefined
    };
    const jsonArray = [itemAtualizado];
    try {
      await this.dynamodbService
        .salvar(jsonArray, this.queryTimeTable, this.urlAtualiza)
        .subscribe(async (response) => {
          console.log("Item atualizado para o próximo dia:", response);
          // Atualiza reservas se necessário
          if (
            itemAtualizado.dataAlteradaLCB &&
            itemAtualizado.horaAlteradaLCB &&
            itemAtualizado.motAlteracao &&
            itemAtualizado.motAlteracao != 0
          ) {
            if (itemAtualizado.area !== "EMB" && itemAtualizado.area !== "EMBMR") {
              await this.AtualizaReservaEmbalagem(itemAtualizado);
            }
            if (
              itemAtualizado.origem == "PlanilhaDiretoExtraLCB"
            ) {
              await this.AtualizaViagemDiretaExtraLCB(itemAtualizado);
            }
          }
          await this.update();
        });
    } catch (err) {
      console.error("Erro ao salvar alteração de dia:", err);
    }
  }

  isDateValid(dateString: string) {
    const date = new Date(dateString);
    return !isNaN(date.getTime());
  }

  zeroSeconds(date: Date): Date {
    const newDate = new Date(date);
    newDate.setSeconds(0, 0);
    return newDate;
  }

  // async atualizaStatus(items: any[]) {
  //   let dataChegadaString = '';
  //   let dataEntradaString = '';
  //   let dataSaidaString = '';
  //   let dataString = '';
  //   let dataHoraString = '';

  //   const seen = new Set<string>();
  //   const viagensUnicas = items.filter(v => {
  //     const id = String(v?.ID ?? '').split('#')[0]; // normaliza "ABC#ghost" -> "ABC"
  //     return id && (seen.has(id) ? false : (seen.add(id), true));
  //   });
  //   for (const item of viagensUnicas) {
  //     let chegou = false;
  //     let entrou = false;
  //     let saiu = false;
  //     let finalizacaoManualLCB = false;
  //     let propertyName = "";
  //     try {
  //       if (item.dataAlteradaLCB) {
  //         dataString = `${item.dataAlteradaLCB}T${item.horaAlteradaLCB}:00.000`;
  //       }
  //       else if (item.dataJanelaTimeTable && item.horaJanelaTimeTable) {
  //         dataString = `${item.dataJanelaTimeTable}T${item.horaJanelaTimeTable}:00.000`;
  //       }
  //       else if (item.dataJanelaDestino1Alterada && (item['Destino 1'] && item['Destino 1'].toUpperCase().includes('LCB'))) {
  //         dataString = `${item.dataJanelaDestino1Alterada}T${item.horaJanelaDestino1Alterada}:00.000`;
  //       }
  //       else if (item.dataJanelaDestino2Alterada && (item['Destino 2'] && item['Destino 2'].toUpperCase().includes('LCB'))) {
  //         dataString = `${item.dataJanelaDestino2Alterada}T${item.horaJanelaDestino2Alterada}:00.000`;
  //       }
  //       else if (item.idContainer && item.Janela) {
  //         dataString = item.Janela;
  //       }
  //       else if (item['Destino 1'] && item['Destino 1'].toUpperCase().includes('LCB')) {
  //         dataString = item['JanelaDestino 1'];
  //         propertyName = "FinalizacaoManualDestino1";
  //         finalizacaoManualLCB = item[propertyName];
  //         // item.FinalizacaoManualDestino1
  //       } else if (item['Destino 2'] && item['Destino 2'].toUpperCase().includes('LCB')) {
  //         dataString = item['JanelaDestino 2'];
  //         propertyName = "FinalizacaoManualDestino2";
  //         finalizacaoManualLCB = item[propertyName];
  //       } else if (item['Janela']) {
  //         dataString = item['Janela'].toString();
  //       } else if (item['JanelaDestino 1']) {
  //         dataString = item['JanelaDestino 1'].toString();
  //       }
  //     } catch {
  //       console.log("com erro!")
  //       console.log(item)
  //     }
  //     if (item['chegada'] && item['chegada'] != "0001-01-01T00:00:00") {
  //       dataChegadaString = item['chegada'];
  //     } else if (item['ChegadaLCB'] && item['ChegadaLCB'] != "0001-01-01T00:00:00") {
  //       dataChegadaString = item['ChegadaLCB'];
  //     } else {
  //       dataChegadaString = "0001-01-01T00:00:00";
  //     }
  //     // dataChegadaString = item['chegada'] ? item['chegada'] : "0001-01-01T00:00:00";
  //     try {
  //       if (dataString.includes("Z")) {
  //         dataString = dataString.replace("Z", "");
  //       }
  //     } catch {
  //       console.log("com erro!")
  //       console.log(dataString)
  //       console.log(item)
  //     }
  //     if (item['entrada'] && item['entrada'] != "0001-01-01T00:00:00") {
  //       dataEntradaString = item['entrada'];
  //     } else if (item['EntradaLCB'] && item['EntradaLCB'] != "0001-01-01T00:00:00") {
  //       dataEntradaString = item['EntradaLCB'];
  //     } else {
  //       dataEntradaString = "0001-01-01T00:00:00";
  //     }
  //     if (item['saida'] && item['saida'] != "0001-01-01T00:00:00") {
  //       dataSaidaString = item['saida'];
  //     } else if (item['SaidaLCB'] && item['SaidaLCB'] != "0001-01-01T00:00:00") {
  //       dataSaidaString = item['SaidaLCB'];
  //     } else {
  //       dataSaidaString = "0001-01-01T00:00:00";
  //     }

  //     if (dataChegadaString.includes("Z")) {
  //       dataChegadaString = dataChegadaString.replace("Z", "");
  //     }
  //     if (dataEntradaString.includes("Z")) {
  //       dataEntradaString = dataEntradaString.replace("Z", "");
  //     }
  //     if (dataSaidaString.includes("Z")) {
  //       dataSaidaString = dataSaidaString.replace("Z", "");
  //     }
  //     let dataJanela = new Date(dataString);
  //     const dataChegada = new Date(dataChegadaString);
  //     const dataEntrada = new Date(dataEntradaString);
  //     const dataSaida = new Date(dataSaidaString);
  //     const dataAtual = new Date();
  //     const dataZero = new Date("0001-01-01T00:00:00");
  //     const dataUndefined = new Date("0001-01-01T00:00:00");

  //     let dataJanelaTolerancia = new Date(dataString);
  //     dataJanelaTolerancia.setHours(dataJanelaTolerancia.getHours() - 1);
  //     dataChegada.setSeconds(0, 0);
  //     dataJanela.setSeconds(0, 0);
  //     dataJanelaTolerancia.setSeconds(0, 0);
  //     let horaRealocadaSistema = new Date(dataJanela.setHours(item.horaSlot));
  //     horaRealocadaSistema.setSeconds(0, 0);
  //     item.horaCompara = horaRealocadaSistema;
  //     if ((dataChegada.getTime() != dataZero.getTime()) && (dataChegada >= dataJanelaTolerancia) && (dataChegada <= horaRealocadaSistema)) {
  //       item['statusChegada'] = 'OK';
  //     } else if (((dataChegada.getTime() != dataZero.getTime()) && (dataChegada < dataJanelaTolerancia)) || ((dataChegada.getTime() != dataZero.getTime() && dataChegada > horaRealocadaSistema))) {
  //       item['statusChegada'] = 'NOK';
  //     } else {
  //       item['statusChegada'] = '';
  //     }

  //     const dataChegadaNoSeconds = this.zeroSeconds(dataChegada);
  //     item.dataChegadaNoSeconds = this.zeroSeconds(dataChegada);
  //     const dataEntradaNoSeconds = this.zeroSeconds(dataEntrada);
  //     const dataSaidaNoSeconds = this.zeroSeconds(dataSaida);
  //     const dataAtualNoSeconds = this.zeroSeconds(dataAtual);

  //     if ((dataChegadaNoSeconds.getTime() != dataZero.getTime()) && (dataChegadaNoSeconds.getTime() != dataUndefined.getTime())) {
  //       chegou = true;
  //     }
  //     if ((dataEntradaNoSeconds.getTime() != dataZero.getTime()) && (dataEntradaNoSeconds.getTime() != dataUndefined.getTime())) {
  //       entrou = true;
  //     }
  //     if ((dataSaidaNoSeconds.getTime() != dataZero.getTime()) && (dataSaidaNoSeconds.getTime() != dataUndefined.getTime())) {
  //       saiu = true;
  //     }
  //     if (!chegou) {
  //       if (horaRealocadaSistema >= dataAtualNoSeconds) {
  //         item.statusChegadaLCB = 'emTempo';
  //       }
  //       else if (horaRealocadaSistema < dataAtualNoSeconds) {
  //         item.statusChegadaLCB = 'atrasado';
  //       }
  //     } else if (chegou) {
  //       if (horaRealocadaSistema >= dataChegadaNoSeconds) {
  //         if (saiu) {
  //           // console.log(item.Plate)
  //           // console.log(horaRealocadaSistema)
  //           // console.log(dataChegadaNoSeconds)
  //           item.statusChegadaLCB = 'finalizadoEmTempo';
  //         } else if (entrou) {
  //           item.statusChegadaLCB = 'chegouEntrouEmTempo';
  //         } else if (!entrou) {
  //           item.statusChegadaLCB = 'chegouNaoEntrouEmTempo';
  //         }
  //       }
  //       else if (horaRealocadaSistema < dataChegadaNoSeconds) {

  //         // if (horaRealocadaSistema < dataChegadaNoSeconds) {
  //         if (saiu) {
  //           item.statusChegadaLCB = 'finalizadoAtrasado';
  //         } else if (entrou) {
  //           item.statusChegadaLCB = 'chegouEntrouAtrasado';
  //         } else if (!entrou) {
  //           item.statusChegadaLCB = 'chegouNaoEntrouAtrasado';
  //         }
  //       }
  //     }

  //     if (item.FinalizadaManual && finalizacaoManualLCB) {
  //       // console.log("esta com finalizada manual")
  //       item.statusChegadaLCB = 'finalizadaManual';
  //     }
  //     // console.log(item.statusChegadaLCB)
  //   }
  // }

  async atualizaStatus(items: any[]): Promise<void> {
    let dataChegadaString = '';
    let dataEntradaString = '';
    let dataSaidaString = '';
    let dataString = '';

    const baseOf = (v: any) => String(v?._idBase ?? v?.ID ?? '').replace(/#.*$/, '');
    const grupos = new Map<string, any[]>();

    for (const v of items ?? []) {
      const b = baseOf(v);
      if (!b) continue;
      if (!grupos.has(b)) grupos.set(b, []);
      grupos.get(b)!.push(v);
    }

    for (const [base, grupo] of grupos) {
      // console.log(grupo)
      // canônico = preferir não-placeholder/twin
      // const item = grupo.find(x => !x?.__placeholder && !x?.__twin) ?? grupo[0];
      for (const item of grupo) {
        item.Plate = item.Plate ? item.Plate.replace(/\s+/g, '') : '';
        let chegou = false;
        let entrou = false;
        let saiu = false;
        let finalizacaoManualLCB = false;
        let propertyName = "";

        try {
          if (item.dataAlteradaLCB) {
            dataString = `${item.dataAlteradaLCB}T${item.horaAlteradaLCB}:00.000`;
          }
          else if (item.dataJanelaTimeTable && item.horaJanelaTimeTable) {
            dataString = `${item.dataJanelaTimeTable}T${item.horaJanelaTimeTable}:00.000`;
          }
          else if (item.dataJanelaDestino1Alterada && (item['Destino 1'] && item['Destino 1'].toUpperCase().includes('LCB'))) {
            dataString = `${item.dataJanelaDestino1Alterada}T${item.horaJanelaDestino1Alterada}:00.000`;
          }
          else if (item.dataJanelaDestino2Alterada && (item['Destino 2'] && item['Destino 2'].toUpperCase().includes('LCB'))) {
            dataString = `${item.dataJanelaDestino2Alterada}T${item.horaJanelaDestino2Alterada}:00.000`;
          }
          else if (item.idContainer && item.Janela) {
            dataString = item.Janela;
          }
          else if (item['Destino 1'] && item['Destino 1'].toUpperCase().includes('LCB')) {
            dataString = item['JanelaDestino 1'];
            propertyName = "FinalizacaoManualDestino1";
            finalizacaoManualLCB = item[propertyName];
          } else if (item['Destino 2'] && item['Destino 2'].toUpperCase().includes('LCB')) {
            dataString = item['JanelaDestino 2'];
            propertyName = "FinalizacaoManualDestino2";
            finalizacaoManualLCB = item[propertyName];
          } else if (item['Janela']) {
            dataString = item['Janela'].toString();
          } else if (item['JanelaDestino 1']) {
            dataString = item['JanelaDestino 1'].toString();
          }
        } catch {
          console.log("com erro!", item);
        }

        if (item['chegada'] && item['chegada'] != "0001-01-01T00:00:00") {
          dataChegadaString = item['chegada'];
        } else if (item['ChegadaLCB'] && item['ChegadaLCB'] != "0001-01-01T00:00:00") {
          dataChegadaString = item['ChegadaLCB'];
        } else {
          dataChegadaString = "0001-01-01T00:00:00";
        }

        try {
          if (typeof dataString === 'string' && dataString.includes("Z")) {
            dataString = dataString.replace("Z", "");
          }
        } catch { console.log("com erro!", dataString, item); }

        if (item['entrada'] && item['entrada'] != "0001-01-01T00:00:00") {
          dataEntradaString = item['entrada'];
        } else if (item['EntradaLCB'] && item['EntradaLCB'] != "0001-01-01T00:00:00") {
          dataEntradaString = item['EntradaLCB'];
        } else {
          dataEntradaString = "0001-01-01T00:00:00";
        }

        if (item['saida'] && item['saida'] != "0001-01-01T00:00:00") {
          dataSaidaString = item['saida'];
        } else if (item['SaidaLCB'] && item['SaidaLCB'] != "0001-01-01T00:00:00") {
          dataSaidaString = item['SaidaLCB'];
        } else {
          dataSaidaString = "0001-01-01T00:00:00";
        }

        if (dataChegadaString.includes("Z")) dataChegadaString = dataChegadaString.replace("Z", "");
        if (dataEntradaString.includes("Z")) dataEntradaString = dataEntradaString.replace("Z", "");
        if (dataSaidaString.includes("Z")) dataSaidaString = dataSaidaString.replace("Z", "");

        // Datas base
        const dataJanelaOrig = new Date(dataString);
        const dataChegada = new Date(dataChegadaString);
        const dataEntrada = new Date(dataEntradaString);
        const dataSaida = new Date(dataSaidaString);
        const dataAtual = new Date();
        const dataZero = new Date("0001-01-01T00:00:00");
        const dataUndefined = new Date("0001-01-01T00:00:00");

        // normalizações
        const dataJanelaTolerancia = new Date(dataJanelaOrig);
        dataJanelaTolerancia.setHours(dataJanelaTolerancia.getHours() - 1);

        const dataJanela = new Date(dataJanelaOrig);

        // hora realocada pelo sistema (usa item.horaSlot)
        const horaRealocadaSistema = new Date(dataJanela);
        const hSlot = (item.horaSlot ?? new Date(item.dataHoraJanela ?? dataJanela).getHours());

        horaRealocadaSistema.setHours(hSlot, 0, 0, 0);
        dataJanela.setSeconds(0, 0);
        dataJanelaTolerancia.setSeconds(0, 0);
        dataChegada.setSeconds(0, 0);

        // status simples OK/NOK
        // let statusChegada;
        // if (item.ID == '68f8eeedc532eb001ec0ce873') {
        //   console.log(item)
        //   console.log('dataChegada', dataChegada)
        //   console.log('dataZero', dataZero)
        //   console.log(dataChegada.getTime() != dataZero.getTime())
        //   console.log((dataChegada >= dataJanelaTolerancia && dataChegada <= horaRealocadaSistema))
        // }
        if (dataChegada.getTime() != dataZero.getTime()) {
          item.statusChegada = (dataChegada >= dataJanelaTolerancia && dataChegada <= horaRealocadaSistema) ? 'OK' : 'NOK';
        }

        // flags auxiliares
        const dataChegadaNoSeconds = this.zeroSeconds(dataChegada);
        const dataEntradaNoSeconds = this.zeroSeconds(dataEntrada);
        const dataSaidaNoSeconds = this.zeroSeconds(dataSaida);
        const dataAtualNoSeconds = this.zeroSeconds(dataAtual);

        if ((dataChegadaNoSeconds.getTime() != dataZero.getTime()) && (dataChegadaNoSeconds.getTime() != dataUndefined.getTime())) {
          chegou = true;
        }
        if ((dataEntradaNoSeconds.getTime() != dataZero.getTime()) && (dataEntradaNoSeconds.getTime() != dataUndefined.getTime())) {
          entrou = true;
        }
        if ((dataSaidaNoSeconds.getTime() != dataZero.getTime()) && (dataSaidaNoSeconds.getTime() != dataUndefined.getTime())) {
          saiu = true;
        }

        // if (item.ID == '68f8eeedc532eb001ec0ce873') {
        //   console.log('statusChegada', item.statusChegada)
        //   console.log('chegou', chegou)
        //   console.log('entrou', entrou)
        //   console.log('saiu', saiu)
        //   console.log('horaRealocadaSistema', horaRealocadaSistema)
        //   console.log('dataJanelaTolerancia', dataJanelaTolerancia)
        //   console.log('dataJanelaOrig', dataJanelaOrig)
        // }

        // let statusChegadaLCB = '';
        if (!chegou) {
          item.statusChegadaLCB = (horaRealocadaSistema >= dataAtualNoSeconds) ? 'emTempo' : 'atrasado';
        } else {
          if (horaRealocadaSistema >= dataChegadaNoSeconds) {
            if (saiu) item.statusChegadaLCB = 'finalizadoEmTempo';
            else if (entrou) item.statusChegadaLCB = 'chegouEntrouEmTempo';
            else item.statusChegadaLCB = 'chegouNaoEntrouEmTempo';
          } else {
            if (saiu) item.statusChegadaLCB = 'finalizadoAtrasado';
            else if (entrou) item.statusChegadaLCB = 'chegouEntrouAtrasado';
            else item.statusChegadaLCB = 'chegouNaoEntrouAtrasado';
          }
        }

        if (item.FinalizadaManual && finalizacaoManualLCB) {
          item.statusChegadaLCB = 'finalizadaManual';
        }

        // 👉 PROPAGA para todos os itens do mesmo _idBase (inclui o ghost #slot2)
        // for (const it of this.timeTableGeral) {
        //   // console.log(it.Plate)
        //   // it.horaCompara = horaRealocadaSistema;
        //   it['statusChegada'] = item.statusChegada;
        //   it['statusChegadaLCB'] = item.statusChegadaLCB;
        // }
      }
    }
  }


  private recalcularSobraRECCONT(): void {
    for (let h = 0; h < 24; h++) {
      const lim = this.limiteVolumes['RECCONT'][h] ?? 0;
      const usado = this.VolumeAtualPorHora['RECCONT']?.[h] ?? 0;
      this.VolumeSobraPorHora['RECCONT'][h] = Math.max(0, lim - usado);
    }
  }

  async somarFluxosFinalizado() {
    console.log('REDISTRIBUIÇÃO')
    this.timeTableExcesso = [];
    let dataHoraString = '';

    const areas = ["RECCONT", "RECSIDER", "EMB", "EMBMR", "EXP", "INT"];

    // zera a grade e contadores no COMEÇO
    for (let h = 0; h < 24; h++) {
      for (const area of areas) {
        this.timeTableGeral[h][area] = [];
      }
    }
    for (const area of areas) {
      this.VolumeAtualPorHora[area] = {};
      this.VolumeSobraPorHora[area] = {};
      this.horasEstouradas[area] ??= {};
      for (let h = 0; h < 24; h++) {
        this.VolumeAtualPorHora[area][h] = 0;
        this.horasEstouradas[area][h] = false;
        this.VolumeSobraPorHora[area][h] = this.limiteVolumes[area][h];
      }
    }

    // for (let i = 0; i < 25; i++) {
    //   this.timeTableGeral[i]['EXP'] = []
    // }
    for (const item of this.totalReservasEXP) {
      if (item.dataAlteradaLCB) {
        dataHoraString = `${item.dataAlteradaLCB}T${item.horaAlteradaLCB}:00.000Z`;
      }
      else if (item.dataJanelaDestino1Alterada && item['Destino 1'] && item['Destino 1'].toUpperCase().includes('LCB')) {
        dataHoraString = `${item.dataJanelaDestino1Alterada}T${item.horaJanelaDestino1Alterada}:00.000Z`;
      }
      else if (item.dataJanelaDestino2Alterada && item['Destino 2'] && item['Destino 2'].toUpperCase().includes('LCB')) {
        dataHoraString = `${item.dataJanelaDestino2Alterada}T${item.horaJanelaDestino2Alterada}:00.000Z`;
      }
      else if (item.dataJanelaOriginal && item.horaJanelaOriginal) {
        dataHoraString = `${item.dataJanelaOriginal}T${item.horaJanelaOriginal}:00.000Z`;
      }
      else {
        dataHoraString = `${item.dataJanelaTimeTable}T${item.horaJanelaTimeTable}:00.000Z`;
      }
      if (item['Destino 1'] && item['Destino 1'].toUpperCase().includes('LCB')) {
        dataHoraString = this.ajustarDataSeDepoisDe2305(dataHoraString);
        await this.ajusteTimeTable(item, 'EXP', dataHoraString, item['Destino 1']);
      } else if (item['Destino 2'] && item['Destino 2'].toUpperCase().includes('LCB')) {
        dataHoraString = this.ajustarDataSeDepoisDe2305(dataHoraString);
        await this.ajusteTimeTable(item, 'EXP', dataHoraString, item['Destino 2']);
      } else if (item['Destino 3'] && item['Destino 3'].toUpperCase().includes('LCB')) {
        dataHoraString = this.ajustarDataSeDepoisDe2305(dataHoraString);
        await this.ajusteTimeTable(item, 'EXP', dataHoraString, item['Destino 3']);
      }
    }

    for (const item of this.itemsContainersReuse) {
      if (item.dataAlteradaLCB) {
        dataHoraString = `${item.dataAlteradaLCB}T${item.horaAlteradaLCB}:00.000Z`;
      }
      else if (item.dataJanelaDestino1Alterada) {
        dataHoraString = `${item.dataJanelaDestino1Alterada}T${item.horaJanelaDestino1Alterada}:00.000Z`;
      }
      else if (item.dataJanelaDestino2Alterada) {
        dataHoraString = `${item.dataJanelaDestino2Alterada}T${item.horaJanelaDestino2Alterada}:00.000Z`;
      }
      else {
        dataHoraString = `${item.dataJanelaTimeTable}T${item.horaJanelaTimeTable}:00.000Z`;
      }
      if (item.destino && item.destino.toUpperCase().includes('LCB')) {
        dataHoraString = this.ajustarDataSeDepoisDe2305(dataHoraString);
        let date1str = dataHoraString.replace("Z", "");
        let janela = new Date(date1str)
        janela.setHours(janela.getHours() + 1);
        await this.ajusteTimeTable(item, 'EXP', janela.toString(), item.destino);
      }
    }

    await this.__fixConsecutiveOverflows('EXP');

    // for (let i = 0; i < 25; i++) {
    //   this.timeTableGeral[i]['RECCONT'] = []
    // }

    this.totalCont = this.itemsContainers;
    this.totalCont = this.totalCont.concat(this.totalReservasRECCONT);

    for (const item of this.totalCont) {
      if (item.dataAlteradaLCB) {
        dataHoraString = `${item.dataAlteradaLCB}T${item.horaAlteradaLCB}:00.000Z`;
      }
      else if (item.dataJanelaDestino1Alterada && item['Destino 1'] && item['Destino 1'].toUpperCase().includes('LCB')) {
        dataHoraString = `${item.dataJanelaDestino1Alterada}T${item.horaJanelaDestino1Alterada}:00.000Z`;
      }
      else if (item.dataJanelaDestino2Alterada && item['Destino 2'] && item['Destino 2'].toUpperCase().includes('LCB')) {
        dataHoraString = `${item.dataJanelaDestino2Alterada}T${item.horaJanelaDestino2Alterada}:00.000Z`;
      }
      else if (item.dataJanelaOriginal && item.horaJanelaOriginal) {
        dataHoraString = `${item.dataJanelaOriginal}T${item.horaJanelaOriginal}:00.000Z`;
      }
      else {
        dataHoraString = `${item.dataJanelaTimeTable}T${item.horaJanelaTimeTable}:00.000Z`;
      }
      dataHoraString = this.ajustarDataSeDepoisDe2305(dataHoraString);
      await this.ajusteTimeTable(item, 'RECCONT', dataHoraString, item.destino);
    }

    await this.__fixConsecutiveOverflows('RECCONT');
    this.recalcularSobraRECCONT();

    // for (let i = 0; i < 25; i++) {
    //   this.timeTableGeral[i]['RECSIDER'] = []
    // }
    this.totalMR = []
    this.totalMR = this.totalItensJetta;

    // console.log('totalMR', this.totalMR)
    this.totalMR = this.totalMR.concat(this.itemsArg);
    this.totalMR = this.totalMR.concat(this.itemsVW);
    this.totalMR = this.totalMR.concat(this.totalReservasRECSIDER);
    for (const item of this.totalMR) {
      try {
        item.Transportadora = item.description ? item.description.includes('JSL') ? 'JSL' : item.description.includes('TCM') ? 'TCM' : item.description.includes('SESE') ? 'SESE' : item.description.includes('LOTS') ? 'LOTS' : item.description.includes('ARG') ? 'RITMO' : 'Outros' : item.transportadora ? item.transportadora : item.Transportadora ? item.Transportadora : 'Outros';
        // item.Fornecedores = item.Fornecedores ? item.Fornecedores : [
        //   item['Fornecedor 1'],
        //   item['Fornecedor 2'],
        //   item['Fornecedor 3'],
        //   item['Fornecedor 4']
        // ].filter(f => !!f && f.trim() !== '').join(', ')
        if (item.dataAlteradaLCB) {
          // console.log('ENTROU ALTERADA LCB')
          // console.log(item)
          dataHoraString = `${item.dataAlteradaLCB}T${item.horaAlteradaLCB}:00.000Z`;
        }
        else if (item.dataJanelaDestino1Alterada && item['Destino 1'] && item['Destino 1'].toUpperCase().includes('LCB')) {
          dataHoraString = `${item.dataJanelaDestino1Alterada}T${item.horaJanelaDestino1Alterada}:00.000Z`;
        }
        else if (item.dataJanelaDestino2Alterada && item['Destino 2'] && item['Destino 2'].toUpperCase().includes('LCB')) {
          dataHoraString = `${item.dataJanelaDestino2Alterada}T${item.horaJanelaDestino2Alterada}:00.000Z`;
        }
        else if (item.dataJanelaDestino3Alterada && item['Destino 3'] && item['Destino 3'].toUpperCase().includes('LCB')) {
          dataHoraString = `${item.dataJanelaDestino3Alterada}T${item.horaJanelaDestino3Alterada}:00.000Z`;
        }
        else if (item.dataJanelaOriginal && item.horaJanelaOriginal) {
          dataHoraString = `${item.dataJanelaOriginal}T${item.horaJanelaOriginal}:00.000Z`;
        }
        else if (item.dataJanela && item.horaJanela) {
          dataHoraString = `${item.dataJanela}T${item.horaJanela}:00.000Z`;
        }
        else if (item.dataJanelaTimeTable) {
          dataHoraString = `${item.dataJanelaTimeTable}T${item.horaJanelaTimeTable}:00.000Z`;
        }
        else if (item.dataJanela && item.horario) {
          dataHoraString = `${item.dataJanela}T${item.horario}:00.000`;
        }
        else if (item['Destino 1'] && item['Destino 1'].toUpperCase().includes('LCB')) {
          dataHoraString = item['JanelaDestino 1'];
        }
        else if (item['Destino 2'] && item['Destino 2'].toUpperCase().includes('LCB')) {
          dataHoraString = item['JanelaDestino 2'];
        }
        else if (item['Destino 3'] && item['Destino 3'].toUpperCase().includes('LCB')) {
          dataHoraString = item['JanelaDestino 3'];
        }
        if (item['Destino 1'] && item['Destino 1'].toUpperCase().includes('LCB')) {
          dataHoraString = this.ajustarDataSeDepoisDe2305(dataHoraString);
          await this.ajusteTimeTable(item, 'RECSIDER', dataHoraString, item['Destino 1']);
        } else if (item['Destino 2'] && item['Destino 2'].toUpperCase().includes('LCB')) {
          dataHoraString = this.ajustarDataSeDepoisDe2305(dataHoraString);
          await this.ajusteTimeTable(item, 'RECSIDER', dataHoraString, item['Destino 2']);
        } else if (item['Destino 3'] && item['Destino 3'].toUpperCase().includes('LCB')) {
          dataHoraString = this.ajustarDataSeDepoisDe2305(dataHoraString);
          await this.ajusteTimeTable(item, 'RECSIDER', dataHoraString, item['Destino 3']);
        }
      } catch {
        console.log(item)
      }
    }

    await this.__fixConsecutiveOverflows('RECSIDER');

    // for (let i = 0; i < 25; i++) {
    //   this.timeTableGeral[i]['EMB'] = []
    // }
    for (const item of this.totalReservasEMB) {
      if (item.dataAlteradaLCB) {
        dataHoraString = `${item.dataAlteradaLCB}T${item.horaAlteradaLCB}:00.000Z`;
      }
      else if (item.dataJanelaOriginal && item.horaJanelaOriginal) {
        dataHoraString = `${item.dataJanelaOriginal}T${item.horaJanelaOriginal}:00.000Z`;
      }
      else {
        dataHoraString = `${item.dataJanelaTimeTable}T${item.horaJanelaTimeTable}:00.000Z`;
      }
      if (item['Destino 1'] && item['Destino 1'].toUpperCase().includes('LCB')) {
        dataHoraString = this.ajustarDataSeDepoisDe2305(dataHoraString);
        await this.ajusteTimeTable(item, 'EMB', dataHoraString, item['Destino 1']);
      } else if (item['Destino 2'] && item['Destino 2'].toUpperCase().includes('LCB')) {
        dataHoraString = this.ajustarDataSeDepoisDe2305(dataHoraString);
        await this.ajusteTimeTable(item, 'EMB', dataHoraString, item['Destino 2']);
      } else if (item['Destino 3'] && item['Destino 3'].toUpperCase().includes('LCB')) {
        dataHoraString = this.ajustarDataSeDepoisDe2305(dataHoraString);
        await this.ajusteTimeTable(item, 'EMB', dataHoraString, item['Destino 3']);
      }
    }

    await this.__fixConsecutiveOverflows('EMB');

    // for (let i = 0; i < 25; i++) {
    //   this.timeTableGeral[i]['EMBMR'] = []
    // }
    for (const item of this.totalReservasEMBMR) {
      if (item.dataAlteradaLCB) {
        dataHoraString = `${item.dataAlteradaLCB}T${item.horaAlteradaLCB}:00.000Z`;
      }
      else if (item.dataJanelaOriginal && item.horaJanelaOriginal) {
        dataHoraString = `${item.dataJanelaOriginal}T${item.horaJanelaOriginal}:00.000Z`;
      }
      else {
        dataHoraString = `${item.dataJanelaTimeTable}T${item.horaJanelaTimeTable}:00.000Z`;
      }
      if (item['Destino 1'] && item['Destino 1'].toUpperCase().includes('LCB')) {
        dataHoraString = this.ajustarDataSeDepoisDe2305(dataHoraString);
        await this.ajusteTimeTable(item, 'EMBMR', dataHoraString, item['Destino 1']);
      } else if (item['Destino 2'] && item['Destino 2'].toUpperCase().includes('LCB')) {
        dataHoraString = this.ajustarDataSeDepoisDe2305(dataHoraString);
        await this.ajusteTimeTable(item, 'EMBMR', dataHoraString, item['Destino 2']);
      } else if (item['Destino 3'] && item['Destino 3'].toUpperCase().includes('LCB')) {
        dataHoraString = this.ajustarDataSeDepoisDe2305(dataHoraString);
        await this.ajusteTimeTable(item, 'EMBMR', dataHoraString, item['Destino 3']);
      }
    }

    await this.__fixConsecutiveOverflows('EMBMR');

    // for (let i = 0; i < 25; i++) {
    //   this.timeTableGeral[i]['INT'] = []
    // }
    for (const item of this.itemsInterplantas) {
      if (item.dataAlteradaLCB && item.dataAlteradaLCB !== undefined) {
        dataHoraString = `${item.dataAlteradaLCB}T${item.horaAlteradaLCB}:00.000Z`;
      }
      else if (item.dataJanelaDestino1Alterada && item.dataJanelaDestino1Alterada !== undefined && item['Destino 1'] && item['Destino 1'].toUpperCase().includes('LCB')) {
        dataHoraString = `${item.dataJanelaDestino1Alterada}T${item.horaJanelaDestino1Alterada}:00.000Z`;
      }
      else if (item.dataJanelaDestino2Alterada && item.dataJanelaDestino2Alterada !== undefined && item['Destino 2'] && item['Destino 2'].toUpperCase().includes('LCB')) {
        dataHoraString = `${item.dataJanelaDestino2Alterada}T${item.horaJanelaDestino2Alterada}:00.000Z`;
      }
      else if (item.dataJanelaOriginal && item.horaJanelaOriginal) {
        dataHoraString = `${item.dataJanelaOriginal}T${item.horaJanelaOriginal}:00.000Z`;
      }
      else {
        dataHoraString = `${item.dataJanelaTimeTable}T${item.horaJanelaTimeTable}:00.000Z`;
      }
      if (item.Local == 'R27' || item.Local == 'R26') {
        dataHoraString = this.ajustarDataSeDepoisDe2305(dataHoraString);
        const ajusteHora = new Date(dataHoraString);
        if (item.dataAlteradaLCB === undefined) {
          ajusteHora.setMinutes(ajusteHora.getMinutes() - 75);
          item.dataJanelaTimeTable = ajusteHora.toISOString().slice(0, 10); // "2024-04-23"
          item.horaJanelaTimeTable = ajusteHora.toISOString().slice(11, 16); // "00:00"  
        }
        await this.ajusteTimeTable(item, 'INT', ajusteHora.toISOString())
      }
      if (item.Local == 'E37') {
        dataHoraString = this.ajustarDataSeDepoisDe2305(dataHoraString);
        const ajusteHora = new Date(dataHoraString);
        try {
          if (item.dataAlteradaLCB === undefined) {
            ajusteHora.setMinutes(ajusteHora.getMinutes() + 90);
            item.dataJanelaTimeTable = ajusteHora.toISOString().slice(0, 10); // "2024-04-23"
            item.horaJanelaTimeTable = ajusteHora.toISOString().slice(11, 16); // "00:00"  
          }
          await this.ajusteTimeTable((item), 'EMB', ajusteHora.toISOString())
        } catch {
          console.log(item)
        }
      }
      if (item.Local != 'E37' && item.Local != 'R27' && item.Local != 'R26') {
        dataHoraString = this.ajustarDataSeDepoisDe2305(dataHoraString);
        const ajusteHora = new Date(dataHoraString);
        if (item.dataAlteradaLCB === undefined) {
          ajusteHora.setMinutes(ajusteHora.getMinutes() - 90);
          item.dataJanelaTimeTable = ajusteHora.toISOString().slice(0, 10); // "2024-04-23"
          item.horaJanelaTimeTable = ajusteHora.toISOString().slice(11, 16); // "00:00"  
        }
        await this.ajusteTimeTable((item), 'INT', ajusteHora.toString())
      }
    }

    await this.__fixConsecutiveOverflows('INT');

    let todasViagens: any[] = [];
    let todasViagensComGhost: any[] = [];
    const vistos = new Set<any>();

    for (let h = 0; h < 24; h++) {
      const porArea = this.timeTableGeral?.[h] || {};
      for (const area of Object.keys(porArea)) {
        for (const it of (porArea[area] || [])) {
          todasViagensComGhost.push(it);
          if (!it || it.__placeholder) continue; // <-- ignora 2º slot do BI-TREM
          if (vistos.has(it)) continue;
          vistos.add(it);
          todasViagens.push(it);
        }
      }
    }

    // Verificação: todo mundo que passou por ajusteTimeTable entrou na grade ou no overflow
    const presentes = new Set<string>();
    for (let h = 0; h < 24; h++) {
      for (const area of Object.keys(this.timeTableGeral?.[h] || {})) {
        for (const it of (this.timeTableGeral[h][area] || [])) {
          const base = String(it._idBase ?? it.ID ?? '').replace(/#.*$/, '');
          if (base) presentes.add(base);
        }
      }
    }
    const over = new Set<string>();
    for (const area of Object.keys(this.overflowTable || {})) {
      for (const it of (this.overflowTable[area] || [])) {
        const base = String(it._idBase ?? it.ID ?? '').replace(/#.*$/, '');
        if (base) over.add(base);
      }
    }

    // se você tiver uma lista local dos itens processados, use-a aqui;
    // se não tiver, faça uma rapidinha com os arrays que você percorreu:
    const revisitar: any[] = []; // ponha aqui os itens que você passou ao ajusteTimeTable
    // ex.: revisitar.push(...this.totalCont, ...this.totalMR, ...this.totalReservasEXP, ...this.totalReservasEMB, ...this.totalReservasEMBMR, ...this.itemsInterplantas);

    const faltando = revisitar.filter(it => {
      const base = String(it._idBase ?? it.ID ?? '').replace(/#.*$/, '');
      return base && !presentes.has(base) && !over.has(base);
    });

    if (faltando.length) {
      console.warn('Itens faltando na grade e no overflow:', faltando.map(x => x.ID));
      // opcional: tente alocar de novo cada faltante pela hora da janela
      for (const it of faltando) {
        const area = it.area ?? 'RECSIDER';
        const dt = new Date(it.dataHoraJanela ?? `${it.dataJanelaTimeTable}T${it.horaJanelaTimeTable}:00.000Z`);
        const h = Math.min(23, Math.floor(((dt.getHours() * 60) + dt.getMinutes() + 55) / 60));
        await this.alocarItem(area, it, h);
      }
    }
    await this.atualizaStatus(todasViagensComGhost);
    // await this.salvarTimeTableNoBanco();    TESTE SEM REALOCAÇÃO

  }

  ajustarDataSeDepoisDe2305(dataHoraStr: string): string {
    // console.log('LOGICA 23 05')
    try {
      const data = new Date(dataHoraStr);
      const horas = data.getHours();
      const minutos = data.getMinutes();
      const totalMinutos = horas * 60 + minutos;
      const limiteMinutos = 23 * 60 + 5;
      if (totalMinutos > limiteMinutos) {
        data.setDate(data.getDate() + 1);
        data.setHours(0, 0, 0, 0);
      }
      return data.toISOString();
    } catch {
      console.log(dataHoraStr)
      return "falhou"
    }
  }
  onFieldTouched() {
    this.campoTocado = true;
  }

  ordenarJanelas(area: string) {
    for (let i = 0; i < 24; i++) {
      this.timeTableGeral[i][area] = this.timeTableGeral[i][area].sort((a, b) => {
        let dataA = a.created;
        let dataB = b.created;
        if (a.lastUpdate) {
          dataA = a.lastUpdate;
        }
        if (b.lastUpdate) {
          dataB = b.lastUpdate;
        }
        const normalizeDate = (date: string) => {
          if (!isNaN(Number(date))) {
            return new Date(Number(date));
          }
          return new Date(date);
        };
        const dateA = normalizeDate(dataA);
        const dateB = normalizeDate(dataB);
        return dateA.getTime() - dateB.getTime();
      });
    }
  }

  somarVolumes() {
    const areas = ['RECCONT', 'RECSIDER', 'EXP', 'INT', 'EMB', 'EMBMR'];
    // Zerar os valores de this.valorItemVolume
    for (let i = 0; i < this.valorItemVolume.length; i++) {
      for (let j = 0; j < areas.length; j++) {
        this.valorItemVolume[i][j] = 0;
      }
    }
    const volumesTotaisPorArea: { [key: string]: number[] } = {};
    areas.forEach((area, i) => {
      volumesTotaisPorArea[area] = [];
      try {
        this.timeTableGeral.forEach((item, index) => {
          item[area].forEach(subItem => {
            const volumesComoNumero = parseFloat(subItem.Volumes);
            if (!isNaN(volumesComoNumero)) {
              this.valorItemVolume[index][i] += volumesComoNumero;
              volumesTotaisPorArea[area].push(volumesComoNumero);
            }
          });
        });
      } catch {
        // console.log(area);
      }
    });
  }

  isISODateValid(dateString: string) {
    const date = new Date(dateString);
    return !isNaN(date.getTime());
  }

  async ajusteTimeTable(item: any, area: string, janela: string, destino?: string): Promise<void> {
    const areatemp = area;
    // if (areatemp == 'RECSIDER') {
    return new Promise<void>(async (resolve) => {
      let date1str = '';
      if (area == 'INT') {
        // date1str = item["Janela"].replace("Z", "");
        if (janela.includes("Z")) {
          date1str = janela?.replace("Z", "");
        } else {
          date1str = janela
        }
      } else if (area == 'RECCONT') {
        if (janela.includes("Z")) {
          date1str = janela?.replace("Z", "");
        } else {
          date1str = janela
        }
      } else if (area == 'RECSIDER') {
        if (janela.includes("Z")) {
          date1str = janela?.replace("Z", "");
        } else {
          date1str = janela
        }
      } else if (area == 'EMB') {
        if (janela.includes("Z")) {
          date1str = janela?.replace("Z", "");
        } else {
          date1str = janela
        }
      } else if (area == 'EMBMR') {
        if (janela.includes("Z")) {
          date1str = janela?.replace("Z", "");
        } else {
          date1str = janela
        }
      } else if (area == 'EXP') {
        if (janela.includes("Z")) {
          date1str = janela?.replace("Z", "");
        } else {
          date1str = janela
        }
      }
      const date1 = new Date(date1str);
      item.dataHoraJanela = date1;
      const horaDoDia = date1.getHours();
      const minutos = date1.getMinutes();

      let dataIgual = await this.compareDatesSemHoras(date1str, this.dataExibir.toDateString());

      if (dataIgual == 0) {
        const totalMin = horaDoDia * 60 + minutos;
        const horaSlot = Math.min(23, Math.floor((totalMin + 55) / 60));
        item.dataHoraJanela = date1;  // guarda para relatórios
        item.area = area;             // idem
        await this.alocarItem(area, item, horaSlot); // ✅ aloca aqui
      }
      // console.log('date1',date1)
      this.itemTimeTable.push({
        ID: item.ID + area,
        Janela: date1str,
        Area: area,
        Plate: item.Plate,
        Volumes: item.Volumes,
        Sequencia: item.SequenciaLCB,
        idContainer: item.idContainer,
        Transportadora: item.Transportadora ? item.Transportadora : item.transportadora ? item.transportadora : item.description ? (item.description.includes('JSL') ? 'JSL' : item.description.includes('TCM') ? 'TCM' : item.description.includes('SESE') ? 'SESE' : item.description.includes('LOTS') ? 'LOTS' : item.description.includes('ARG') ? 'JSL-ARG' : 'Outros') : '',
        Fornecedores: [
          item['Fornecedor 1'],
          item['Fornecedor 2'],
          item['Fornecedor 3'],
          item['Fornecedor 4']
        ].filter(f => !!f && f.trim() !== '').join(', '),
        tableName: this.tabelaPrevisao
      });
      resolve();
    });
  }

  ///////////////////////////////////   inicio dos testes  ///////////////////////////////////////////

  async alocarItem(area: string, item: any, horaInicial: number): Promise<boolean> {
    // ID base estável (mesmo se item.ID mudar depois)
    const baseId = item._idBase ?? String(item?.ID ?? '').replace(/#.*$/, '');
    item._idBase = baseId;

    const group = this.__mkGroup(item); // { baseId, item, isBiTrem, slots, volume }

    for (let h = Math.max(0, Math.floor(horaInicial)); h < 24; h++) {
      // tenta colocar direto; se não couber, empurra alguém de h→h+1 (cascata)
      if (await this.__ensurePlaceAtHour(area, h, group)) {
        return true;
      }
      // se falhar, tenta em h+1, repetindo a lógica
    }

    // não coube em 0..23 ⇒ overflow
    item.overflow = true;
    await this.registrarOverflow(area, item, 'alocarItem');
    // ou: await this.salvarAlteracaoDiaSeguinte(item);
    return false;
  }

  private __mkGroup(item: any) {
    const baseId = item._idBase ?? String(item?.ID ?? '').replace(/#.*$/, '');
    const isBiTrem = item?.["Transport Type"] === "BI-TREM";
    return { baseId, item, isBiTrem, slots: isBiTrem ? 2 : 1, volume: Number(item?.Volumes) || 0 };
  }

  private __baseIdOf(x: any): string {
    return String(x?._idBase ?? x?.ID ?? '').replace(/#.*$/, '');
  }

  private __getVolumeLimit(area: string, h: number): number {
    const base = Number(this.limiteVolumes?.[area]?.[h] ?? 0);
    if (area === 'RECSIDER') {
      const sobra = Number(this.VolumeSobraPorHora?.['RECCONT']?.[h] ?? 0);
      return base + sobra;
    }
    return base;
  }

  private async __canPlace(
    area: string,
    h: number,
    group: { slots: number; volume: number; },
    allowConsecutiveOverflow = false  // << novo
  ): Promise<boolean> {
    const fila = this.timeTableGeral[h][area] ?? (this.timeTableGeral[h][area] = []);
    const slotLimit = await this.getSlotLimit(h, area);
    if (fila.length + group.slots > slotLimit) return false;

    this.VolumeAtualPorHora[area] ??= {};
    this.VolumeAtualPorHora[area][h] ??= 0;

    const volumeAtual = this.VolumeAtualPorHora[area][h];
    const volumeLimit = this.__getVolumeLimit(area, h);
    const volComItem = volumeAtual + group.volume;

    const willOverflow = volComItem > volumeLimit;
    const prevOverflow = h > 0 && this.horasEstouradas?.[area]?.[h - 1] === true;

    // normal: pode estourar 1 hora se a anterior NÃO estourou
    if (!allowConsecutiveOverflow) {
      return !willOverflow || !prevOverflow;
    }
    // modo resgate: permite estourar mesmo se a anterior estourou
    return true;
  }

  private __placeGroup(area: string, h: number, group: any): void {
    const fila = this.timeTableGeral[h][area] ?? (this.timeTableGeral[h][area] = []);

    if (group.isBiTrem) {
      // 1º slot: item real (mantém referência para espelhar status)
      fila.push(group.item);

      // 2º slot: placeholder sem volume (ID diferente para não ser deduplicado)
      const ghost = {
        ...group.item,
        __placeholder: true,       // marca como slot "fantasma"
        _idBase: group.baseId,     // garante que remove/move por baseId traga os 2 slots
        ID: `${group.item.ID}#slot2`,
        Volumes: 0
      };
      fila.push(ghost);
    } else {
      fila.push(group.item);
    }

    // Atualiza volume/estouro **apenas 1x** (do group inteiro)
    this.VolumeAtualPorHora[area] ??= {};
    this.VolumeAtualPorHora[area][h] ??= 0;
    this.VolumeAtualPorHora[area][h] += group.volume;

    const limit = this.__getVolumeLimit(area, h);
    this.horasEstouradas[area] ??= {};
    this.horasEstouradas[area][h] = this.VolumeAtualPorHora[area][h] > limit;

    this.atualizarControleVolume(area, h, this.VolumeAtualPorHora[area][h], limit);
  }

  private __removeGroup(area: string, h: number, group: any): void {
    const fila = this.timeTableGeral[h][area] ?? (this.timeTableGeral[h][area] = []);
    let toRemove = group.slots;
    for (let i = fila.length - 1; i >= 0 && toRemove > 0; i--) {
      if (this.__baseIdOf(fila[i]) === group.baseId) {
        fila.splice(i, 1);
        toRemove--;
      }
    }

    this.VolumeAtualPorHora[area] ??= {};
    this.VolumeAtualPorHora[area][h] ??= 0;
    this.VolumeAtualPorHora[area][h] = Math.max(0, this.VolumeAtualPorHora[area][h] - group.volume);

    const limit = this.__getVolumeLimit(area, h);
    this.horasEstouradas[area] ??= {};
    this.horasEstouradas[area][h] = this.VolumeAtualPorHora[area][h] > limit;

    this.atualizarControleVolume(area, h, this.VolumeAtualPorHora[area][h], limit);
  }

  // troque o corpo de __listVictimGroups por isto:
  private __listVictimGroups(area: string, h: number, excludeBaseId: string): any[] {
    const fila = this.timeTableGeral[h][area] ?? [];
    const vistos = new Set<string>();
    const groups: any[] = [];

    // coleta únicos por _idBase (ignora placeholders)
    for (let i = fila.length - 1; i >= 0; i--) {
      const it = fila[i];
      if (!it || it.__placeholder) continue;
      const base = this.__baseIdOf(it);
      if (!base || base === excludeBaseId || vistos.has(base)) continue;
      vistos.add(base);
      groups.push(this.__mkGroup(it));
    }

    // prioriza quem “fica mais perto” do horário alvo (h+1)
    return groups.sort((a, b) => {
      const da = Math.abs(this.getHoraSlotDeItem(a.item) - (h + 1));
      const db = Math.abs(this.getHoraSlotDeItem(b.item) - (h + 1));
      if (da !== db) return da - db;

      // desempate: mais leve primeiro (menos chance de manter estouro)
      const va = Number(a.item?.Volumes) || 0;
      const vb = Number(b.item?.Volumes) || 0;
      return va - vb;
    });
  }


  private async __ensurePlaceAtHour(
    area: string,
    h: number,
    group: any,
    allowConsecutiveOverflow = false // << novo
  ): Promise<boolean> {
    // Cabe direto?
    if (await this.__canPlace(area, h, group, allowConsecutiveOverflow)) {
      group.item.horaSlot = h;
      this.__placeGroup(area, h, group);
      return true;
    }

    // Empurrar vítimas h -> h+1
    const tentados = new Set<string>();
    while (true) {
      const candidates = this.__listVictimGroups(area, h, group.baseId)
        .filter(g => !tentados.has(g.baseId));
      if (candidates.length === 0) return false;

      let abriuEspaco = false;

      for (const victim of candidates) {
        tentados.add(victim.baseId);
        this.__removeGroup(area, h, victim);

        let moved: boolean;
        if (h + 1 < 24) {
          moved = await this.__ensurePlaceAtHour(area, h + 1, victim, allowConsecutiveOverflow);
        } else {
          victim.item.overflow = true;
          await this.registrarOverflow(area, victim.item, 'tail-evict-23');
          moved = true;
        }

        if (!moved) {
          this.__placeGroup(area, h, victim); // rollback
          continue;
        }

        // tentou abrir espaço novamente
        if (await this.__canPlace(area, h, group, allowConsecutiveOverflow)) {
          group.item.horaSlot = h;
          this.__placeGroup(area, h, group);
          return true;
        }
        abriuEspaco = true;
      }

      if (!abriuEspaco) return false;
    }
  }

  private async __fixConsecutiveOverflows(area: string): Promise<void> {
    for (let h = 0; h < 23; h++) {
      // enquanto houver 2 horas consecutivas estouradas, desata movendo h+1 → h+2 (com cascata)
      while (this.horasEstouradas?.[area]?.[h] && this.horasEstouradas?.[area]?.[h + 1]) {

        const candidatos = this.__listVictimGroups(area, h + 1, /*exclude*/ "");
        if (candidatos.length === 0) break;

        let resolveu = false;

        for (const victim of candidatos) {
          // tira temporariamente de h+1
          this.__removeGroup(area, h + 1, victim);

          // tenta colocar em h+2 com a sua cascata
          const ok = (h + 2 < 24)
            ? await this.__ensurePlaceAtHour(area, h + 2, victim)
            : false;

          if (!ok) {
            // se não deu, devolve e tenta outro candidato;
            // se for o último horário (23), sua __ensurePlaceAtHour já faz tail-evict.
            this.__placeGroup(area, h + 1, victim);
            continue;
          }

          // moveu com sucesso; verifica se o par consecutivo acabou
          resolveu = true;
          break;
        }

        if (!resolveu) break; // não conseguiu mover mais nada; evita loop infinito
      }
    }
  }


  //////************************************************* */




  // async alocarItem(area: string, item: any, horaSlot: number): Promise<boolean> {
  //   const fila = this.timeTableGeral[horaSlot][area];
  //   const limit = await this.getSlotLimit(horaSlot, area);

  //   // --- ID base estável (fixa na 1ª vez) ---
  //   // Ex.: "ABC#2" -> "ABC", e grava em item._idBase para futuras chamadas.
  //   const baseId = item._idBase ?? String(item?.ID ?? '').replace(/#.*$/, '');
  //   item._idBase = baseId;

  //   // --- BI-TREM? (ocupa 2 slots) ---
  //   const isBiTrem = item?.["Transport Type"] === "BI-TREM";
  //   const slotsNecessarios = isBiTrem ? 2 : 1;

  //   // --- GUARD anti-duplicação por _idBase ---
  //   // Conta quantas entradas já existem na fila com o mesmo _idBase (independe do ID atual).
  //   const jaNaFila = fila.filter(x => x && (x._idBase ?? String(x.ID ?? '').replace(/#.*$/, '')) === baseId).length;
  //   if (jaNaFila >= slotsNecessarios) {
  //     // Já está completamente alocado neste horário (evita cair para 4 slots se o ID mudar).
  //     return true;
  //   }

  //   // --- Limite de volume (RECSIDER usa sobra da RECCONT) ---
  //   let volumeLimit: number;
  //   if (area === "RECSIDER") {
  //     const sobraReccont = this.VolumeSobraPorHora?.["RECCONT"]?.[horaSlot] ?? 0;
  //     volumeLimit = (this.limiteVolumes[area]?.[horaSlot] ?? 0) + sobraReccont;
  //   } else {
  //     volumeLimit = this.limiteVolumes[area]?.[horaSlot] ?? Infinity;
  //   }

  //   // --- Controle de volume ---
  //   this.VolumeAtualPorHora[area] ??= {};
  //   this.VolumeAtualPorHora[area][horaSlot] ??= 0;
  //   const volumeAtual = this.VolumeAtualPorHora[area][horaSlot];
  //   const volItem = Number(item?.Volumes) || 0;
  //   const volumeComItem = volumeAtual + volItem;

  //   // Pode estourar 1 hora, nunca 2 seguidas
  //   const horaAnteriorEstourou = horaSlot > 0 && this.horasEstouradas?.[area]?.[horaSlot - 1] === true;
  //   const podeAlocar =
  //     (volumeComItem <= volumeLimit) ||
  //     (volumeComItem > volumeLimit && !horaAnteriorEstourou);

  //   // --- Checagem de slots ---
  //   if ((fila.length + slotsNecessarios) <= limit && podeAlocar) {
  //     // Marca o slot no item
  //     item.horaSlot = horaSlot;

  //     if (isBiTrem) {
  //       fila.push(item, item);
  //     } else {
  //       fila.push(item);
  //     }

  //     // Atualiza volume/estouro
  //     this.VolumeAtualPorHora[area][horaSlot] = volumeComItem;
  //     this.atualizarControleVolume(area, horaSlot, volumeComItem, volumeLimit);
  //     return true;
  //   }

  //   // --- Se não coube: empurra até 23; senão overflow ---
  //   const proximaHora = horaSlot + 1;
  //   if (proximaHora < 24) {
  //     return await this.alocarItem(area, item, proximaHora);
  //   } else {
  //     item.overflow = true;
  //     await this.registrarOverflow(area, item, 'alocarItem');
  //     return false;
  //   }
  // }

  private async registrarOverflow(area: string, item: any, origem: string) {
    if (!item) return;
    item.overflow = true;
    // console.warn(`[${origem}] Item ${item.ID} foi para overflow (${area})`);
    // console.log(item.Plate);
    // console.log(item.horaJanelaTimeTable);
    // console.log(item);
    this.overflowTable[area] ??= [];
    // evita duplicidade no overflow
    if (!this.overflowTable[area].includes(item)) {
      this.overflowTable[area].push(item);
      // await this.salvarAlteracaoDiaSeguinte(item);
    }
  }

  private getHoraSlotDeItem(item: any): number {
    const dt = new Date(item.dataHoraJanela ?? item.dataAlteradaLCB ?? item.Janela ?? item.dataISO ?? item.data);
    const h = dt.getHours();
    const m = dt.getMinutes();
    return Math.min(23, Math.floor((h * 60 + m + 55) / 60));
  }

  private ordenarViagensParaAlocacao(itens: any[]): any[] {
    return [...itens].sort((a, b) => {
      const ha = this.getHoraSlotDeItem(a);
      const hb = this.getHoraSlotDeItem(b);
      if (ha !== hb) return ha - hb;

      const pa = (a["Transport Type"] === "BI-TREM") ? 0 : 1;
      const pb = (b["Transport Type"] === "BI-TREM") ? 0 : 1;
      if (pa !== pb) return pa - pb;

      // opcional: maior volume primeiro
      const va = Number(a.Volumes) || 0;
      const vb = Number(b.Volumes) || 0;
      if (va !== vb) return vb - va;

      // tie-breaker estável (ID)
      return String(a.ID ?? '').localeCompare(String(b.ID ?? ''));
    });
  }

  async agendarTudoOrdenado(itens: any[]): Promise<void> {
    // 1) agrupa por área (ajuste as chaves conforme seus dados)
    const porArea: Record<string, any[]> = {};
    for (const it of itens) {
      const area = it.area ?? it.Area ?? it['Área'] ?? 'RECSIDER'; // fallback
      (porArea[area] ??= []).push(it);
    }

    // 2) para cada área: ordena e aloca
    for (const area of Object.keys(porArea)) {
      const lista = this.ordenarViagensParaAlocacao(porArea[area]);
      for (const it of lista) {
        const h = this.getHoraSlotDeItem(it);
        await this.alocarItem(area, it, h);
      }
    }
  }



  // async empurrarFila(horaInicial: number, area: string, item: any): Promise<void> {
  //   let horaAtual = horaInicial;
  //   while (horaAtual < 24) {
  //     const sucesso = await this.alocarItem(area, item, horaAtual);
  //     if (sucesso) return; // ✅ alocado com sucesso, encerra
  //     horaAtual++; // tenta a próxima hora
  //   }
  //   // 🔸 Se chegou aqui, não coube em nenhuma hora — vai para overflow
  //   console.warn(`empurrarFila → Item ${item.ID} foi para overflow (${area})`);
  //   item.overflow = true;
  //   this.overflowTable[area] ??= [];
  //   this.overflowTable[area].push(item);
  //   await this.salvarAlteracaoDiaSeguinte(item);
  // }

  private atualizarControleVolume(
    area: string,
    horaSlot: number,
    volumeComItem: number,
    volumeLimit: number
  ): void {
    // normaliza horaSlot como número inteiro
    const h = Math.floor(Number(horaSlot));

    // garante inicialização dos objetos de controle
    this.ultimoEstouroPorArea = this.ultimoEstouroPorArea ?? {};
    if (this.ultimoEstouroPorArea[area] === undefined) {
      this.ultimoEstouroPorArea[area] = -999;
    }

    this.horasEstouradas = this.horasEstouradas ?? {};
    if (!this.horasEstouradas[area]) {
      this.horasEstouradas[area] = {};
    }

    this.VolumeSobraPorHora = this.VolumeSobraPorHora ?? {};
    if (!this.VolumeSobraPorHora[area]) {
      this.VolumeSobraPorHora[area] = {};
    }

    this.VolumeAtualPorHora = this.VolumeAtualPorHora ?? {};
    if (!this.VolumeAtualPorHora[area]) {
      this.VolumeAtualPorHora[area] = {};
    }

    // protege volumeLimit
    if (volumeLimit === undefined || volumeLimit === null || isNaN(Number(volumeLimit))) {
      volumeLimit = Infinity;
    }

    // atualiza o volume atual para este horário (é o total já com o item)
    this.VolumeAtualPorHora[area][h] = Number(volumeComItem) || 0;

    // atualiza flags e sobra
    if (this.VolumeAtualPorHora[area][h] > volumeLimit) {
      this.ultimoEstouroPorArea[area] = h;
      this.horasEstouradas[area][h] = true;
      this.VolumeSobraPorHora[area][h] = 0;
    } else {
      this.ultimoEstouroPorArea[area] = -999;
      this.horasEstouradas[area][h] = false;
      this.VolumeSobraPorHora[area][h] = volumeLimit - this.VolumeAtualPorHora[area][h];
    }
  }

  getVolumeLimit(hora: number, area: string): number {
    return this.limiteVolumes[area]?.[hora] ?? 0; // 0 ou outro fallback
  }

  async getLocais(): Promise<void> {
    const filtro = '';
    (await this.dynamodbService.getItems(this.tableNameLocation, this.urlConsulta, filtro)).subscribe(
      (response: any) => {
        if (response.statusCode === 200) {
          try {
            const items = JSON.parse(response.body);
            if (Array.isArray(items)) {
              this.locais = items;
              // console.log(this.locais)
              this.locaisName = this.locais.map(item => item.local);
            } else {
              console.error('Invalid items data:', items);
            }
          } catch (error) {
            console.error('Error parsing JSON:', error);
          }
        } else {
          console.error('Invalid response:', response);
        }
      },
      (error: any) => {
        console.error(error);
      }
    );
  }

  // async getItemsTabelaTimeTable(): Promise<void> {
  //   const filtro = '';
  //   this.itemsMontarTimeTable = []
  //   try {
  //     const response: any = await lastValueFrom(
  //       this.dynamodbService.getItems('timeTableLCB', this.urlConsulta, filtro)
  //     );
  //     if (response.statusCode === 200) {
  //       const items = JSON.parse(response.body);
  //       // console.log(this.timeTableGeral)
  //       // console.log(items)
  //       // console.log(this.dataExibir)
  //       const dataComparar = new Date(this.dataExibir).toLocaleString('sv-SE').split(' ')[0]
  //       // console.log(dataComparar)
  //       if (Array.isArray(items)) {
  //         this.itemsMontarTimeTable = items.filter(item => item.dataAlteradaLCB ? item.dataAlteradaLCB == dataComparar : item.dataJanelaTimeTable == dataComparar);
  //         // console.log(this.itemsMontarTimeTable)
  //       } else {
  //         console.error('Invalid items data:', items);
  //       }
  //     } else {
  //       console.error('Invalid response:', response);
  //     }
  //   } catch (error) {
  //     console.error('Erro no getSlots:', error);
  //   }
  // }


  async getSlots(): Promise<void> {
    const filtro = '';
    try {
      const response: any = await lastValueFrom(
        this.dynamodbService.getItems('slotsRecebimentos', this.urlConsulta, filtro)
      );

      if (response.statusCode === 200) {
        const items = JSON.parse(response.body);
        // console.log(items)
        if (Array.isArray(items)) {
          this.slotsRecebimentos = items[0];
          this.buildSlotLimits();
          this.buildSlotLimitsCriacaoHTML();
        } else {
          console.error('Invalid items data:', items);
        }
      } else {
        console.error('Invalid response:', response);
      }
    } catch (error) {
      console.error('Erro no getSlots:', error);
    }
  }

  async getVeiculosLab(): Promise<void> {
    try {
      const response: any = await new Promise(async (resolve, reject) => {
        (await this.dynamodbService.getItems(this.queryVeiculosLab, this.urlConsulta, '')).subscribe(
          (res: any) => resolve(res),
          (error: any) => reject(error)
        );
      });
      if (response.statusCode === 200) {
        try {
          const items = JSON.parse(response.body);
          if (Array.isArray(items)) {
            this.veiculosLab = items
              .map(item => ({ ...item, checked: false }));
          } else {
            console.error('Invalid items data:', items);
          }
        } catch (error) {
          console.error('Error parsing JSON:', error);
        }
      } else {
        console.error('Invalid response:', response);
      }
    } catch (error) {
      console.error(error);
    }
  }

  async getFornecedoresFromDynamoDB(): Promise<void> {
    //console.log("entrou em getFornecedoresFromDynamoDB")
    try {
      const response: any = await new Promise(async (resolve, reject) => {
        (await this.dynamodbService.getItems(this.query3, this.urlConsulta, '')).subscribe(
          (res: any) => resolve(res),
          (error: any) => reject(error)
        );
      });
      if (response.statusCode === 200) {
        try {
          const items = JSON.parse(response.body);
          // //console.log(items)
          if (Array.isArray(items)) {
            this.fornecedores = items.map(item => ({ ...item, checked: false }));
            // Adiciona a chave 'checked' a cada item, com valor inicial como false
            this.fornecedores = this.fornecedores.sort((a, b) => a.local.localeCompare(b.local));
          } else {
            console.error('Invalid items data:', items);
          }
        } catch (error) {
          console.error('Error parsing JSON:', error);
        }
      } else {
        console.error('Invalid response:', response);
      }
    } catch (error) {
      console.error(error);
    }
  }

  compareDates(date1str: string, date2str: string): number {
    let dateSTRsemZ = date1str.replace("Z", "");
    let dateSTR2semZ = date2str.replace("Z", "");
    const date1 = new Date(dateSTRsemZ);
    const date2 = new Date(dateSTR2semZ);
    const timestamp1 = date1.getTime();
    const timestamp2 = date2.getTime();
    // //console.log(date1)
    // //console.log(date2)
    if (timestamp1 < timestamp2) {
      return -1; // date1 é anterior a date2
    } else if (timestamp1 > timestamp2) {
      return 1; // date1 é posterior a date2
    } else {
      return 0; // date1 é igual a date2
    }
  }

  compareDates2(date1str: string, date2str: string): number {
    const date1 = new Date(date1str);
    const date2 = new Date(date2str);
    const timestamp1 = date1.getTime();
    const timestamp2 = date2.getTime();
    // //console.log(date1)
    // //console.log(date2)
    if (timestamp1 < timestamp2) {
      return -1; // date1 é anterior a date2
    } else if (timestamp1 > timestamp2) {
      return 1; // date1 é posterior a date2
    } else {
      return 0; // date1 é igual a date2
    }
  }

  isValorValido(value: any): boolean {
    // const data = this.isDateValid(value);
    return value !== '' && value !== null && value !== undefined;
  }

  editDialog(item: any): void {
    this.campoTocado = false;
    console.log(item)
    // console.log(item.dataJanelaTimeTable)
    this.atualPlate = item.Plate;
    const companyUsuarioLogado = this.usuarioLogado.company?.toLowerCase();
    const transportadoraItem = item.Transportadora?.toLowerCase();
    // console.log(item.Transportadora)
    // console.log(this.usuarioLogado.company)
    if (this.usuarioLogado.role == '2' || this.usuarioLogado.role == '9' || this.usuarioLogado.role == '7' || (this.usuarioLogado.role == '3' && transportadoraItem.includes(companyUsuarioLogado))) {
      this.item = { ...item };
      if (item.description && item.description?.includes("JSL")) {
        this.item.transportadora = "JSL"
      }
      else if (item.description && item.description?.includes("TCM")) {
        this.item.transportadora = "TCM"
      }
      else if (item.description && item.description?.includes("ARG")) {
        this.item.transportadora = "JSL"
      }
      else if (item.Transportadora) {
        this.item.transportadora = item.Transportadora
      }
      else {
        this.item.transportadora = "Sem registro"
      }
      this.item.Plate = item.Plate;
      this.item.Volumes = item.Volumes;
      this.item.idContainer = item.idContainer;
      this.item.forn1 = (item["Destino 1"] && item["Destino 1"].toUpperCase().includes('LCB')) ? item["Destino 1"] : (item["Destino 2"] && item["Destino 2"].toUpperCase().includes('LCB')) ? item["Destino 2"] :
        (item["Destino 3"] && item["Destino 3"].toUpperCase().includes('LCB')) ? item["Destino 3"] : (item["destino"] && item["destino"].toUpperCase().includes('LCB')) ? item["destino"] : item.forn1
      this.item.jan1 = (item["Destino 1"] && item["Destino 1"].toUpperCase().includes('LCB')) ? item["JanelaDestino 1"] : (item["Destino 2"] && item["Destino 2"].toUpperCase().includes('LCB')) ? item["JanelaDestino 2"] :
        (item["Destino 3"] && item["Destino 3"].toUpperCase().includes('LCB')) ? item["JanelaDestino 3"] : (item["destino"] && item["destino"].toUpperCase().includes('LCB')) ? item["Janela"] : this.item.jan1
      this.item.destinoIndex = (item["Destino 1"] && item["Destino 1"].toUpperCase().includes('LCB')) ? "Destino 1" : (item["Destino 2"] && item["Destino 2"].toUpperCase().includes('LCB')) ? "Destino 2" :
        (item["Destino 3"] && item["Destino 3"].toUpperCase().includes('LCB')) ? "Destino 3" : "semIndex"
      this.item.janelaIndex = (item["Destino 1"] && item["Destino 1"].toUpperCase().includes('LCB')) ? "JanelaDestino 1" : (item["Destino 2"] && item["Destino 2"].toUpperCase().includes('LCB')) ? "JanelaDestino 2" :
        (item["Destino 3"] && item["Destino 3"].toUpperCase().includes('LCB')) ? "JanelaDestino 3" : "semIndex"
      const dataHoraString = this.item.jan1;
      this.item.dataAlteradaLCB = item.dataAlteradaLCB ? item.dataAlteradaLCB :
        item.dataJanelaDestino1Alterada && (item["Destino 1"] && item["Destino 1"].toUpperCase().includes('LCB')) ? item.dataJanelaDestino1Alterada : item.dataJanelaDestino2Alterada && (item["Destino 2"] && item["Destino 2"].toUpperCase().includes('LCB')) ? item.dataJanelaDestino2Alterada : null;
      this.item.horaAlteradaLCB = item.horaAlteradaLCB ? item.horaAlteradaLCB : item.horaJanelaDestino1Alterada && (item["Destino 1"] && item["Destino 1"].toUpperCase().includes('LCB')) ? item.horaJanelaDestino1Alterada : item.horaJanelaDestino2Alterada && (item["Destino 2"] && item["Destino 2"].toUpperCase().includes('LCB')) ? item.horaJanelaDestino2Alterada : null;
      this.item.motAlteracao = item.motAlteracao;
      this.item.tableName = item.tableName;
      this.item.ID = item.ID
      this.dialogOpen = true;
      // console.log(this.item)
    } else {
      const confirmacao = window.confirm("Usuário não autorizado!");
      // Verifica se o usuário confirmou a ação
      if (confirmacao) {
        this.dialogOpen = false;
      }
    }
  }

  async calculoConsumo(container: any): Promise<any> {
    let atualLocation = { local: "", latitude: 0, longitude: 0 };
    let distance1 = [0, 0];
    let distance2 = [0, 0];
    let distanceTotal = [0, 0];
    const origemLocation = this.findLocationByName(container.terminalOrigem, this.locais);
    atualLocation = await this.findLocationByName(container.terminalAtual, this.locais);
    const destinoLocation = await this.findLocationByName(container.destino, this.locais);
    if (origemLocation && atualLocation) {
      const origemLocationNumber = this.convertItem(origemLocation);
      var atualLocationNumber = this.convertItem(atualLocation);
      distance1 = await this.calcularRota([origemLocationNumber.longitude, origemLocationNumber.latitude], [atualLocationNumber.longitude, atualLocationNumber.latitude]);
      container.distanceTrecho1 = distance1[0];
    }
    if (destinoLocation && atualLocation) {
      const destinoLocationNumber = this.convertItem(destinoLocation);
      var atualLocationNumber = this.convertItem(atualLocation);
      distance2 = await this.calcularRota([destinoLocationNumber.longitude, destinoLocationNumber.latitude], [atualLocationNumber.longitude, atualLocationNumber.latitude]);
      container.distanceTrecho2 = distance2[0];
    }
    container['Transport Type'] = container['Transport Type'] ? container['Transport Type'] : this.veiculosLab.find((veiculo: { placa: any; }) => veiculo.placa == container.Plate)
      ? this.veiculosLab.find((veiculo: { placa: any; }) => veiculo.placa == container.Plate).modelo
      : "R450 LA4x2MNA";
    container.emissao = this.veiculosLab.find((veiculo: { modelo: any; }) => veiculo.modelo == container['Transport Type'])
      ? this.veiculosLab.find((veiculo: { modelo: any; }) => veiculo.modelo == container['Transport Type']).emissoes
      : 0;
    container.consumo = this.veiculosLab.find((veiculo: { modelo: any; }) => veiculo.modelo == container['Transport Type'])
      ? this.veiculosLab.find((veiculo: { modelo: any; }) => veiculo.modelo == container['Transport Type']).consumo
      : 0;
    container.emissaoTrecho1 = (container.distanceTrecho1 * container.emissao) / container.consumo;
    container.emissaoTrecho2 = (container.distanceTrecho2 * container.emissao) / container.consumo;

    container['Total Distance'] = container.distanceTrecho1 + container.distanceTrecho2;
    container['emissaoTotal'] = container.emissaoTrecho1 + container.emissaoTrecho2;
    return container;
  }

  findLocationByName(name: string, locations: any[]): Location {
    return locations['find']((location: { local: string; }) => location.local === name);
  }


  convertItem(item: any): any {
    return {
      ID: item.ID,
      latitude: parseFloat(item.latitude),  // Convertendo latitude para número
      local: item.local,
      longitude: parseFloat(item.longitude),  // Convertendo longitude para número
      tableName: item.tableName
    };
  }

  async calcularRota(startLocation: number[], endLocation: number[]): Promise<[number, number]> {
    try {
      const response: any = await (await this.dynamodbService.getRota("https://klyufov1p0.execute-api.sa-east-1.amazonaws.com/v1/POST", startLocation, endLocation)).toPromise();
      if (response.statusCode === 200) {
        const data = response.body;
        if (data) {
          const distance = data.Distance;
          const durationSeconds = data.DurationSeconds;
          return [distance, durationSeconds];
        } else {
          console.error('Data not found in the response:', data);
          return [0, 0];
        }
      } else {
        console.error('Invalid response:', response);
        return [0, 0];
      }
    } catch (error) {
      console.error('Error processing data:', error);
      return [0, 0];
    }
  }

  editDialog2(area: string): void {
    if (this.usuarioLogado.role == '2' || this.usuarioLogado.role == '9' || this.usuarioLogado.role == '5' || this.usuarioLogado.role == '7' ||
      (this.usuarioLogado.role == '3' && area == 'RECSIDER') || (this.usuarioLogado.role == '3' && area == 'EMB') || (this.usuarioLogado.role == '3' && area == 'EMBMR')) {
      // console.log("edit 2");
      this.edit2 = true;
      this.item = [];
      this.item.Plate = null;
      // this.item.Transportadora = null;
      this.item.Volumes = null;
      this.item.idContainer = null;
      this.item.forn1 = "LCB DEMARCHI";
      this.item['Destino 1'] = "LCB DEMARCHI";
      this.item.dataJanelaOriginal = this.item.dataJanelaOriginal;
      this.item.horaJanelaOriginal = this.item.horaJanelaOriginal;
      this.item.dataJanelaTimeTable = null;
      this.item.horaJanelaTimeTable = null;
      // this.item.jan1 = "";
      this.item['JanelaDestino 1'] = null;
      this.item.destinoIndex = 'Destino 1';
      this.item.janelaIndex = 'JanelaDestino 1';
      this.item.date = new Date();
      this.item.area = this.usuarioLogado.role == '3' && this.usuarioLogado.company != 'LOTS' && this.usuarioLogado.company != 'SESE' ? 'EMBMR' :
        this.usuarioLogado.role == '3' && (this.usuarioLogado.company == 'LOTS' || this.usuarioLogado.company == 'SESE') ? 'EMB' : area;
      const currentDate = new Date().getTime();
      this.item.created = currentDate.toString();
      this.item.createdBy = this.usuarioLogado.id;
      const id = new Date().getTime();
      this.item.ID = id.toString();
      this.item.tableName = this.queryTimeTable;
      this.dialogOpen = true;
    } else {
      const confirmacao = window.confirm("Usuário não autorizado!");
      // Verifica se o usuário confirmou a ação
      if (confirmacao) {
        this.dialogOpen = false;
      }
    }
  }

  async salvarNovo() {
    if (this.item.idContainer && this.item.idContainer != "") {
      this.item.ID = this.item.idContainer;
    }
    if (this.item.Plate != this.atualPlate) {
      await this.calculoConsumo(this.item);
    }
    let dataHoraString;
    let dataHora;
    let formattedDate;
    try {
      dataHoraString = `${this.item.dataJanelaTimeTable}T${this.item.horaJanelaTimeTable}:00.000Z`;
      dataHora = new Date(dataHoraString);
      formattedDate = dataHora.toISOString();
    } catch {
      console.log("erro na data")
    }
    this.isLoading = true;
    const fornecedores = this.item['Fornecedores'];
    this.item = {
      ...this.item,
      // "ID": this.item.ID,
      "transportadora": this.item.transportadora,
      "lastUpdate": new Date(),
      "UpdateByUser": this.usuarioLogado.id,
      "area": this.item.area,
      "dataJanela": this.item.dataJanelaTimeTable,
      "horaJanela": this.item.horaJanelaTimeTable,
      "dataJanelaTimeTable": this.item.dataJanelaTimeTable,
      "horaJanelaTimeTable": this.item.horaJanelaTimeTable,
      "tableName": this.item.tableName ? this.item.tableName : this.queryTimeTable
    }
    // console.log(this.item)
    const itemsDataString = JSON.stringify(this.item); // Acessa a string desejada
    const modifiedString = itemsDataString.replace(/\\"/g, '"'); // Realiza a substituição na string
    // Converter a string JSON para um objeto JavaScript
    const jsonObject = JSON.parse(modifiedString) as { [key: string]: string };
    // Converter o objeto JavaScript de volta para uma string JSON
    const modifiedJsonString = JSON.stringify(jsonObject);
    // Converter a string JSON para um objeto JavaScript
    const jsonObject2 = JSON.parse(modifiedJsonString) as { tableName: string, ID: string, acao: string };
    // Criar um array contendo o objeto
    const jsonArray = [jsonObject2];
    console.log(jsonArray)
    await this.dynamodbService.salvar(jsonArray, this.queryTimeTable, this.urlAtualiza).subscribe(async response => {
      // console.log(response)
      if ((this.item.dataAlteradaLCB && this.item.horaAlteradaLCB && this.item.motAlteracao && this.item.motAlteracao != 0) && (this.item.area != "EMB" && this.item.area != "EMBMR")) {
        await this.AtualizaReservaEmbalagem(this.item);
      }
      if (this.item.dataAlteradaLCB && this.item.horaAlteradaLCB && this.item.motAlteracao && this.item.motAlteracao != 0 && this.item.origem == 'PlanilhaDiretoExtraLCB') {
        await this.AtualizaViagemDiretaExtraLCB(this.item);
      }
      await this.update();
      this.edit2 = false;
      this.dialogOpen = false;
      this.isLoading = false;
    }, error => {
      console.log(error);
    });
  }

  // async salvarTimeTableNoBanco() {
  //   console.log('entrou no salvar')
  //   const areas = ["EXP", "RECSIDER", "RECCONT", "EMB", "EMBMR", "INT"];
  //   const timeTableConvertida: any[] = [];

  //   for (let hora = 0; hora < 24; hora++) {
  //     for (const area of areas) {
  //       const itens = this.timeTableGeral[hora][area];
  //       if (!itens || itens.length === 0) continue;
  //       itens.forEach((item: any, index: number) => {
  //         const novoItem = {
  //           tableName: 'timeTableLCB',
  //           ID: item.ID?.toString(),
  //           ['Destino 1']: item['Destino 1']?.toString(),
  //           ['Destino 2']: item['Destino 2']?.toString(),
  //           ['Destino 3']: item['Destino 3']?.toString(),
  //           ['Destino 4']: item['Destino 4']?.toString(),

  //           ['Janela 1']: item['Janela 1']?.toString(),
  //           ['Janela 2']: item['Janela 2']?.toString(),
  //           ['Janela 3']: item['Janela 3']?.toString(),
  //           ['Janela 4']: item['Janela 4']?.toString(),
  //           ['Janela']: item['Janela']?.toString(),

  //           ['JanelaDestino 1']: item['JanelaDestino 1']?.toString(),
  //           ['JanelaDestino 2']: item['JanelaDestino 2']?.toString(),
  //           ['JanelaDestino 3']: item['JanelaDestino 3']?.toString(),
  //           ['JanelaDestino 4']: item['JanelaDestino 4']?.toString(),
  //           dataAlteradaLCB: item.dataAlteradaLCB?.toString(),
  //           horaAlteradaLCB: item.horaAlteradaLCB?.toString(),
  //           dataHoraJanela: item.dataHoraJanela?.toString(),
  //           horaJanela: item.horaJanela?.toString(),
  //           dataJanelaOriginal: item.dataJanelaOriginal?.toString(),
  //           horaJanelaOriginal: item.horaJanelaOriginal?.toString(),
  //           dataJanelaTimeTable: item.dataJanelaTimeTable?.toString(),
  //           horaJanelaTimeTable: item.horaJanelaTimeTable?.toString(),
  //           horaSlot: item.horaSlot?.toString(),
  //           jan1: item.jan1?.toString(),
  //           SaidaLCB: item.SaidaLCB?.toString(),
  //           EntradaLCB: item.EntradaLCB?.toString(),
  //           ChegadaLCB: item.ChegadaLCB?.toString(),
  //           SequenciaLCB: item.SequenciaLCB?.toString(),
  //           Volumes: item.Volumes?.toString(),
  //           Plate: item.Plate?.toString(),
  //           Transportadora: item.Transportadora?.toString() || item.transportadora?.toString(),
  //           CTNRAlugado: item.CTNRAlugado?.toString(),
  //           idContainer: item.idContainer?.toString(),
  //           lastUpdate: item.lastUpdate?.toString(),
  //           created: item.created?.toString(),
  //           statusChegadaLCB: item.statusChegadaLCB?.toString(),
  //           area: item.area?.toString()
  //         }
  //         timeTableConvertida.push(novoItem);
  //       });
  //     }
  //   }
  //   await this.dynamodbService.salvar(timeTableConvertida, 'timeTableLCB', this.urlAtualiza)
  //     .subscribe({
  //       next: response => console.log('✅ Salvou com sucesso:', response),
  //       error: error => console.error('❌ Erro ao salvar:', error)
  //     });
  // }

  // async atualizarStatusTimeTableNoBanco(itens: any[]): Promise<void> {
  //   // console.log('🚀 Entrou no atualizarStatusTimeTableNoBanco');
  //   if (!Array.isArray(itens)) return;
  //   for (let i = 0; i < this.itemsMontarTimeTable.length; i++) {
  //     const item = this.itemsMontarTimeTable[i];
  //     const itemCorresponde = itens.find(it => it.ID === item.ID);
  //     if (!itemCorresponde) continue;
  //     // Atualiza diretamente o elemento do array
  //     this.itemsMontarTimeTable[i] = {
  //       ...item,
  //       SaidaLCB: itemCorresponde.SaidaLCB?.toString() || null,
  //       EntradaLCB: itemCorresponde.EntradaLCB?.toString() || null,
  //       ChegadaLCB: itemCorresponde.ChegadaLCB?.toString() || null,
  //       SequenciaLCB: itemCorresponde.SequenciaLCB?.toString() || null,
  //       lastUpdate: itemCorresponde.lastUpdate?.toString() || new Date().toISOString(),
  //       statusChegadaLCB: itemCorresponde.statusChegadaLCB?.toString() || 'pendente',
  //       tableName: 'timeTableLCB'
  //     };
  //   }
  // }

  // async salvarStatusAtualizado(items: any) {
  //   await this.dynamodbService.salvar(items, 'timeTableLCB', this.urlAtualiza)
  //     .subscribe({
  //       next: response => console.log('✅ Salvou com sucesso:', response),
  //       error: error => console.error('❌ Erro ao salvar:', error)
  //     });
  // }


  reconstruirTimeTableGeral(items: any[]) {
    // Inicializa o timeTableGeral vazio
    const areas = ["EXP", "RECSIDER", "RECCONT", "EMB", "EMBMR", "INT"];
    const timeTableGeral: any[] = [];
    // Cria estrutura base [hora][area] = []
    for (let hora = 0; hora < 24; hora++) {
      const obj: any = {};
      for (const area of areas) {
        obj[area] = [];
      }
      timeTableGeral.push(obj);
    }
    // Preenche com os itens vindos do banco
    items.forEach(item => {
      const horaSlot = parseInt(item.horaSlot);
      const area = item.area;
      if (isNaN(horaSlot) || !areas.includes(area)) {
        console.warn("⛔ Item ignorado, hora/área inválida:", item);
        return;
      }
      // Adiciona o item na posição correta
      timeTableGeral[horaSlot][area].push({
        ...item,
        atualizadoEm: new Date().toISOString()
      });
    });
    return timeTableGeral;
  }


  async reservaEmbalagem(item: any) {
    this.isLoading = true;
    this.dialogOpen = false;
    const currentDate = new Date().getTime();
    let janelaStr = '';
    let destino = '';
    let janela = new Date();
    this.item.coletaEmbalagem = true;
    if (item.dataJanelaDestino1Alterada) {
      janelaStr = `${item.dataJanelaDestino1Alterada}T${item.horaJanelaDestino1Alterada}:00.000Z`;
      janela = new Date(janelaStr);
    }
    else if (item.dataJanelaDestino2Alterada) {
      janelaStr = `${item.dataJanelaDestino2Alterada}T${item.horaJanelaDestino2Alterada}:00.000Z`;
      janela = new Date(janelaStr);
    }
    else if (item.dataAlteradaLCB) {
      janelaStr = `${item.dataAlteradaLCB}T${item.horaAlteradaLCB}:00.000Z`;
      janela = new Date(janelaStr);
    }
    else if (item['Destino 1'] && item['Destino 1'].toUpperCase().includes('LCB')) {
      destino = item["Destino 1"];
      janelaStr = item["JanelaDestino 1"];
      janela = new Date(janelaStr)
    } else if (item['Destino 2'] && item['Destino 2'].toUpperCase().includes('LCB')) {
      destino = item["Destino 2"];
      janelaStr = item["JanelaDestino 2"];
      janela = new Date(janelaStr);
    } else if (item['Destino 3'] && item['Destino 3'].toUpperCase().includes('LCB')) {
      destino = item["Destino 3"];
      janelaStr = item["JanelaDestino 3"];
      janela = new Date(janelaStr);
    }
    // console.log(janela)
    janela.setHours(janela.getHours() + 1);
    // console.log(janela)
    janelaStr = janela.toISOString()
    const exists = this.totalReservasEMBMR.some((existingItem: { ID: any; }) => existingItem.ID === item.ID);

    if (!exists) {
      this.item = item;
      this.item.ID = item.ID + "EMBMR";
      this.item.dataJanela = janelaStr.slice(0, 10); // "2024-04-23"
      this.item.horaJanela = janelaStr.slice(11, 16); // "00:00"  
      this.item.dataJanelaTimeTable = janelaStr.slice(0, 10); // "2024-04-23"
      this.item.horaJanelaTimeTable = janelaStr.slice(11, 16); // "00:00"  
      this.item.dataAlteradaLCB = janelaStr.slice(0, 10); // "2024-04-23"
      this.item.horaAlteradaLCB = janelaStr.slice(11, 16); // "00:00"  
      this.item.area = "EMBMR";
      this.item.Plate = item.Plate;
      this.item.Plate = item.Plate;
      this.item.date = new Date();
      this.item.tableName = this.queryTimeTable;
      this.item.created = currentDate.toString();
      this.item.createdBy = this.usuarioLogado.id;
      const itemsDataString = JSON.stringify(this.item); // Acessa a string desejada
      const modifiedString = itemsDataString.replace(/\\"/g, '"'); // Realiza a substituição na string
      // Converter a string JSON para um objeto JavaScript
      const jsonObject = JSON.parse(modifiedString) as { [key: string]: string };
      // Converter o objeto JavaScript de volta para uma string JSON
      const modifiedJsonString = JSON.stringify(jsonObject);
      // Converter a string JSON para um objeto JavaScript
      const jsonObject2 = JSON.parse(modifiedJsonString) as { tableName: string, ID: string, acao: string };
      // Criar um array contendo o objeto
      const jsonArray = [jsonObject2];
      // console.log(jsonArray)
      await this.dynamodbService.salvar(jsonArray, this.queryTimeTable, this.urlAtualiza).subscribe(async response => {
        // console.log(response)
        await this.update();
        this.edit2 = false;
        this.dialogOpen = false;
        this.isLoading = false;
      }, error => {
        console.log(error);
      });
      // this.itemsMRColetaEmbalagem.push(item);
    }
    else {
      return;
    }
    // }
    // });
  }

  async AtualizaReservaEmbalagem(item: any) {
    // console.log(item)
    const exists = this.totalReservasEMB.some((existingItem: { ID: any; }) => existingItem.ID === item.ID);
    const existsMR = this.totalReservasEMBMR.some((existingItem: { ID: any; }) => existingItem.ID === item.ID);
    // Se não existir, adiciona o item
    if (!exists && !existsMR) {
      return
    } else {
      this.isLoading = true;
      this.dialogOpen = false;
      let janelaStr = '';
      let destino = '';
      let janela = new Date();
      if (item.dataJanelaDestino1Alterada) {
        janelaStr = `${item.dataJanelaDestino1Alterada}T${item.horaJanelaDestino1Alterada}:00.000Z`;
        janela = new Date(janelaStr);
      }
      else if (item.dataJanelaDestino2Alterada) {
        janelaStr = `${item.dataJanelaDestino2Alterada}T${item.horaJanelaDestino2Alterada}:00.000Z`;
        janela = new Date(janelaStr);
      }
      else if (item.dataAlteradaLCB) {
        janelaStr = `${item.dataAlteradaLCB}T${item.horaAlteradaLCB}:00.000Z`;
        janela = new Date(janelaStr);
      }
      if (existsMR) {
        janela.setHours(janela.getHours() + 1);
      }
      janelaStr = janela.toISOString();
      this.item = item;
      this.item.ID = exists ? item.ID + "EMB" : item.ID + "EMBMR";
      this.item.area = exists ? "EMB" : "EMBMR";
      this.item.tableName = "janelasTimeTable"
      this.item.dataAlteradaLCB = janelaStr.slice(0, 10); // "2024-04-23"
      this.item.horaAlteradaLCB = janelaStr.slice(11, 16); // "00:00"  
      this.item.lastUpdate = new Date();
      this.item.UpdateByUser = this.usuarioLogado.id;
      const itemsDataString = JSON.stringify(this.item); // Acessa a string desejada
      const modifiedString = itemsDataString.replace(/\\"/g, '"'); // Realiza a substituição na string
      // Converter a string JSON para um objeto JavaScript
      const jsonObject = JSON.parse(modifiedString) as { [key: string]: string };
      // Converter o objeto JavaScript de volta para uma string JSON
      const modifiedJsonString = JSON.stringify(jsonObject);
      // Converter a string JSON para um objeto JavaScript
      const jsonObject2 = JSON.parse(modifiedJsonString) as { tableName: string, ID: string, acao: string };
      // Criar um array contendo o objeto
      const jsonArray = [jsonObject2];
      // console.log(jsonArray)
      await this.dynamodbService.salvar(jsonArray, this.queryTimeTable, this.urlAtualiza).subscribe(async response => {
        // console.log(response)
        await this.update();
        this.edit2 = false;
        this.dialogOpen = false;
        this.isLoading = false;
      }, error => {
        console.log(error);
      });
    }
  }

  async criarVolumesSlots() {
    this.isLoading = true;
    const areas = [
      { nome: "EXP", origem: this.volumesHoraExp },
      { nome: "RECSIDER", origem: this.volumesHoraRecsider },
      { nome: "RECCONT", origem: this.volumesHoraRecCont },
      { nome: "EMB", origem: this.volumesHoraEmb },
      { nome: "EMBMR", origem: this.volumesHoraEmbMR },
      { nome: "INT", origem: this.volumesHoraInt },
    ];
    const slotsVolumes: any = {
      ID: "configInicial",
      tableName: "slotsRecebimentosVolumes"
    };
    for (const { nome, origem } of areas) {
      const volumes: { [key: string]: number } = {};
      for (let h = 0; h < 24; h++) {
        volumes[h.toString()] = origem[h];
      }
      slotsVolumes[nome] = JSON.stringify(volumes);
    }
    const jsonArray = [slotsVolumes];
    this.dynamodbService.salvar(jsonArray, "slotsRecebimentosVolumes", this.urlAtualiza).subscribe({
      next: () => {
        console.log('Programação slots salva com sucesso.');
        this.update();
        this.dialogOpenVolumes = false;
        // this.isLoading = false;
      },
      error: (err) => {
        console.error('Erro ao salvar slots:', err);
        this.isLoading = false;
      }
    });
  }


  async AtualizaViagemDiretaExtraLCB(item: any) {
    // console.log(item)
    await this.getItemsFromDiretasExtraLCB();
    const exists = this.ViagensLCBDiretasExtras.some((existingItem: { ID: any; }) => existingItem.ID === item.ID);
    console.log('exists ', exists)
    // Se não existir, adiciona o item
    if (!exists) {
      return
    } else {
      this.isLoading = true;
      this.dialogOpen = false;
      let janelaStr = '';
      let destino = '';
      let janela = new Date();
      if (item.dataJanelaDestino1Alterada) {
        janelaStr = `${item.dataJanelaDestino1Alterada}T${item.horaJanelaDestino1Alterada}:00.000Z`;
        janela = new Date(janelaStr);
      }
      else if (item.dataJanelaDestino2Alterada) {
        janelaStr = `${item.dataJanelaDestino2Alterada}T${item.horaJanelaDestino2Alterada}:00.000Z`;
        janela = new Date(janelaStr);
      }
      else if (item.dataAlteradaLCB) {
        janelaStr = `${item.dataAlteradaLCB}T${item.horaAlteradaLCB}:00.000Z`;
        janela = new Date(janelaStr);
      }
      janelaStr = janela.toISOString();
      this.item = item;
      this.item.dataAlteradaLCB = janelaStr.slice(0, 10); // "2024-04-23"
      this.item.horaAlteradaLCB = janelaStr.slice(11, 16); // "00:00"  
      // this.item.horaJanela = janelaStr.slice(11, 16); // "00:00"  
      this.item.tableName = 'Viagens-LCB-Diretas-Extras';
      this.item.lastUpdate = new Date();
      this.item.UpdateByUser = this.usuarioLogado.id;
      const itemsDataString = JSON.stringify(this.item); // Acessa a string desejada
      const modifiedString = itemsDataString.replace(/\\"/g, '"'); // Realiza a substituição na string
      // Converter a string JSON para um objeto JavaScript
      const jsonObject = JSON.parse(modifiedString) as { [key: string]: string };
      // Converter o objeto JavaScript de volta para uma string JSON
      const modifiedJsonString = JSON.stringify(jsonObject);
      // Converter a string JSON para um objeto JavaScript
      const jsonObject2 = JSON.parse(modifiedJsonString) as { tableName: string, ID: string, acao: string };
      // Criar um array contendo o objeto
      const jsonArray = [jsonObject2];
      console.log(jsonArray)
      await this.dynamodbService.salvar(jsonArray, 'Viagens-LCB-Diretas-Extras', this.urlAtualiza).subscribe(async response => {
        // console.log(response)
        await this.update();
        this.edit2 = false;
        this.dialogOpen = false;
        this.isLoading = false;
      }, error => {
        console.log(error);
      });
    }
  }

  async reutilizarEXP(item: any) {
    // console.log(item)
    this.isLoading = true;
    this.dialogOpen = false;
    const currentDate = new Date().getTime();
    let janelaStr = '';
    let destino = '';
    let janela = new Date();
    if (item['Destino 1'] && item['Destino 1'].toUpperCase().includes('LCB')) {
      destino = item["Destino 1"];
      janelaStr = item["JanelaDestino 1"];
      janela = new Date(janelaStr)
    } else if (item['Destino 2'] && item['Destino 2'].toUpperCase().includes('LCB')) {
      destino = item["Destino 2"];
      janelaStr = item["JanelaDestino 2"];
      janela = new Date(janelaStr)
    } else if (item['Destino 3'] && item['Destino 3'].toUpperCase().includes('LCB')) {
      destino = item["Destino 3"];
      janelaStr = item["JanelaDestino 3"];
      janela = new Date(janelaStr)
    }
    janela.setHours(janela.getHours() + 1);
    const exists = this.totalReservasEXP.some((existingItem: { ID: any; }) => existingItem.ID === item.ID);
    if (!exists) {
      this.item = item;
      this.item["Destino 1"] = destino;
      this.item["JanelaDestino 1"] = janela;
      this.item.area = "EXP";
      this.item.tableName = this.queryTimeTable;
      this.item.created = currentDate.toString();
      const itemsDataString = JSON.stringify(this.item);
      const modifiedString = itemsDataString.replace(/\\"/g, '"');
      const jsonObject = JSON.parse(modifiedString) as { [key: string]: string };
      const modifiedJsonString = JSON.stringify(jsonObject);
      const jsonObject2 = JSON.parse(modifiedJsonString) as { tableName: string, ID: string, acao: string };
      const jsonArray = [jsonObject2];
    }
    else {
      this.dialogOpen = false;
      this.isLoading = false;
    }
  }

  async salvar() {
    console.log(this.item)
    if ((this.item.dataAlteradaLCB && this.item.horaAlteradaLCB && this.item.motAlteracao && this.item.motAlteracao != 0) ||
      (this.item.dataAlteradaLCB === undefined && this.item.horaAlteradaLCB === undefined) ||
      (this.item.dataAlteradaLCB === null && this.item.horaAlteradaLCB === null)
    ) {
      if (this.item.idContainer && this.item.idContainer != "") {
        this.item.ID = this.item.idContainer;
      }
      if (this.item.idContainer && this.item.dataAlteradaLCB && this.item.horaAlteradaLCB) {
        this.item.dataJanelaTimeTable = this.item.dataAlteradaLCB;
        this.item.horaJanelaTimeTable = this.item.horaAlteradaLCB;
      }
      if (this.item.Plate != this.atualPlate) {
        await this.calculoConsumo(this.item);
      }
      let dataHoraString;
      let dataHora;
      let formattedDate;
      try {
        dataHoraString = `${this.item.dataJanelaTimeTable}T${this.item.horaJanelaTimeTable}:00.000Z`;
        dataHora = new Date(dataHoraString);
        formattedDate = dataHora.toISOString();
      } catch {
        dataHoraString = `${this.item.dataJanelaDestino1}T${this.item.horaJanelaDestino1}:00.000Z`;
        dataHora = new Date(dataHoraString);
        formattedDate = dataHora.toISOString();
        console.log(dataHoraString)
        console.log(dataHora)
      }
      this.isLoading = true;

      const fornecedores = this.item['Fornecedores']
        ? this.item['Fornecedores']
        : [
          this.item['Fornecedor 1'],
          this.item['Fornecedor 2'],
          this.item['Fornecedor 3'],
          this.item['Fornecedor 4']
        ]
          .filter(f => !!f && f.trim() !== '')
          .join(', ');
      // console.log(this.item)

      this.item = {
        ...this.item,
        "ID": this.item.ID,
        "lastUpdate": new Date(),
        "UpdateByUser": this.usuarioLogado.id,
        "area": this.item.area,
        // "dataJanelaDestino1": this.item.dataJanelaDestino1,
        // "horaJanelaDestino1": this.item.horaJanelaDestino1,
        // "dataJanela": this.item.dataJanelaTimeTable,
        // "horaJanela": this.item.horaJanelaTimeTable,
        "dataAlteradaLCB": this.item.dataAlteradaLCB,
        "horaAlteradaLCB": this.item.horaAlteradaLCB,
        "dataJanelaDestino1Alterada": this.item['Destino 1'] && this.item['Destino 1'].toUpperCase().includes('LCB') ? this.item.dataAlteradaLCB : undefined,
        "horaJanelaDestino1Alterada": this.item['Destino 1'] && this.item['Destino 1'].toUpperCase().includes('LCB') ? this.item.horaAlteradaLCB : undefined,
        // "dataJanelaDestino2": this.item.dataJanelaDestino2,
        // "horaJanelaDestino2": this.item.horaJanelaDestino2,
        "dataJanelaDestino2Alterada": this.item['Destino 2'] && this.item['Destino 2'].toUpperCase().includes('LCB') ? this.item.dataAlteradaLCB : undefined,
        "horaJanelaDestino2Alterada": this.item['Destino 2'] && this.item['Destino 2'].toUpperCase().includes('LCB') ? this.item.horaAlteradaLCB : undefined,
        "motAlteracao": this.item.motAlteracao ?? 0,
        // [this.item.janelaIndex]: formattedDate,
        // "dataJanela": dataHoraString,
        // "JanelaDestino 1": this.item["JanelaDestino 1"] ? this.item["JanelaDestino 1"] : formattedDate,
        // "jan1": formattedDate,
        "Plate": this.item.Plate,
        "Volumes": this.item.Volumes,
        "idContainer": this.item.idContainer,
        "Transportadora": this.item.transportadora,
        'Fornecedor 1': this.item['Fornecedor 1'],
        'Fornecedores': fornecedores,
        // 'Fornecedores': this.item['Fornecedor 1'],
        "tableName": this.item.tableName ? this.item.tableName : this.queryTimeTable,
        [this.item.destinoIndex]: this.item.forn1
      }
      const itemsDataString = JSON.stringify(this.item); // Acessa a string desejada
      const modifiedString = itemsDataString.replace(/\\"/g, '"'); // Realiza a substituição na string
      // Converter a string JSON para um objeto JavaScript
      const jsonObject = JSON.parse(modifiedString) as { [key: string]: string };
      // Converter o objeto JavaScript de volta para uma string JSON
      const modifiedJsonString = JSON.stringify(jsonObject);
      // Converter a string JSON para um objeto JavaScript
      const jsonObject2 = JSON.parse(modifiedJsonString) as { tableName: string, ID: string, acao: string };
      // Criar um array contendo o objeto
      const jsonArray = [jsonObject2];
      // console.log(jsonArray)
      await this.dynamodbService.salvar(jsonArray, this.queryTimeTable, this.urlAtualiza).subscribe(async response => {
        // console.log(response)
        if ((this.item.dataAlteradaLCB && this.item.horaAlteradaLCB && this.item.motAlteracao && this.item.motAlteracao != 0) && (this.item.area != "EMB" && this.item.area != "EMBMR")) {
          await this.AtualizaReservaEmbalagem(this.item);
        }
        if (this.item.dataAlteradaLCB && this.item.horaAlteradaLCB && this.item.motAlteracao && this.item.motAlteracao != 0 && this.item.origem == 'PlanilhaDiretoExtraLCB') {
          await this.AtualizaViagemDiretaExtraLCB(this.item);
        }
        await this.update();
        this.edit2 = false;
        this.dialogOpen = false;
        this.isLoading = false;
      }, error => {
        console.log(error);
      });
    } else {
      this.campoTocado = true;
      alert("Formulario incompleto!")
      this.isLoading = false;
    }
  }

  async salvarSlots() {
    this.isLoading = true;
    const dataAtual = new Date();
    const dataLocal = new Date().toLocaleString('sv-SE'); // formato ISO local
    this.slotsRecebimentos = {
      ...this.slots,
      // ...this.slotsRecebimentos,
      "ID": '1',
      "lastUpdate": dataLocal,
      "UpdateByUser": this.usuarioLogado.id,
      "tableName": 'slotsRecebimentos'
    }
    // console.log(this.slotsRecebimentos)
    const itemsDataString = JSON.stringify(this.slotsRecebimentos); // Acessa a string desejada
    const modifiedString = itemsDataString.replace(/\\"/g, '"'); // Realiza a substituição na string
    // Converter a string JSON para um objeto JavaScript
    const jsonObject = JSON.parse(modifiedString) as { [key: string]: string };
    // Converter o objeto JavaScript de volta para uma string JSON
    const modifiedJsonString = JSON.stringify(jsonObject);
    // Converter a string JSON para um objeto JavaScript
    const jsonObject2 = JSON.parse(modifiedJsonString) as { tableName: string, ID: string, acao: string };
    // Criar um array contendo o objeto
    const jsonArray = [jsonObject2];
    // console.log(jsonArray)
    await this.dynamodbService.salvar(jsonArray, '', this.urlAtualiza).subscribe(async response => {
      this.buildSlotLimits();
      this.buildSlotLimitsCriacaoHTML();
      // console.log(this.areaSlotCounts)
      await this.update();
      this.edit2 = false;
      this.dialogOpenSlots = false;
      this.isLoading = false;
    }, error => {
      console.log(error);
    });
  }

  async buildSlotLimits() {
    const defaultLimit = {
      RECSIDER: Number(this.slotsRecebimentos.slotRecsider),
      RECCONT: Number(this.slotsRecebimentos.slotReccontainer),
      EMB: Number(this.slotsRecebimentos.slotEmb),
      EMBMR: Number(this.slotsRecebimentos.slotEmbMR),
      EXP: Number(this.slotsRecebimentos.slotExp),
      INT: Number(this.slotsRecebimentos.slotInt),
    };

    const limits: { [hora: number]: { [area: string]: number } } = {};
    for (let hora = 0; hora <= 23; hora++) {
      limits[hora] = { ...defaultLimit };
    }

    const horariosReduzidos: number[] = [
      this.slotsRecebimentos.horarioAlmoco,
      this.slotsRecebimentos.horarioTrocaTurno,
      this.slotsRecebimentos.horarioJanta,
    ].map(Number); // converte todas strings para número

    horariosReduzidos.forEach(hora => {
      limits[hora] = {
        RECSIDER: Number(this.slotsRecebimentos.slotRecsiderReduzido),
        RECCONT: Number(this.slotsRecebimentos.slotReccontainerReduzido),
        EMB: Number(this.slotsRecebimentos.slotEmbReduzido),
        EMBMR: Number(this.slotsRecebimentos.slotEmbMRReduzido),
        EXP: Number(this.slotsRecebimentos.slotExpReduzido),
        INT: Number(this.slotsRecebimentos.slotIntReduzido),
      };
    });

    this.slotLimits = limits;
    // console.log(this.slotLimits)
  }

  // constrói slotLimitsCriacaoHTML
  async buildSlotLimitsCriacaoHTML() {
    // console.log(this.slotsRecebimentos)
    this.slotLimitsCriacaoHTML = {
      RECSIDER: Number(this.slotsRecebimentos.slotRecsider),
      RECCONT: Number(this.slotsRecebimentos.slotReccontainer),
      EMB: Number(this.slotsRecebimentos.slotEmb),
      EMBMR: Number(this.slotsRecebimentos.slotEmbMR),
      EXP: Number(this.slotsRecebimentos.slotExp),
      INT: Number(this.slotsRecebimentos.slotInt),
    };
    // console.log(this.slotsRecebimentos.slotRecsider)
    // console.log(this.slotLimitsCriacaoHTML['RECSIDER'])

    const areas = ['RECSIDER', 'RECCONT', 'EMB', 'EMBMR', 'EXP', 'INT'];
    await areas.forEach(async area => {
      this.areaSlotCounts[area] = await this.getSlotLimitArea(area);
      // console.log(this.areaSlotCounts[area])
    });
  }

  async salvarTodosDeUmaVez(itens: any[]) {
    // this.isLoading = true;
    await itens.forEach(item => {
      item.tableName = this.tabelaPrevisao;
      item.updateBy = this.usuarioLogado.id;
      item.lastUpdate = new Date().toLocaleString('sv-SE');
    })
    try {
      // console.log(itens)
      await firstValueFrom(
        this.dynamodbService.salvar(itens, this.tabelaPrevisao, this.urlAtualiza)
      );
      console.log('Todos os itens foram salvos com sucesso!');
    } catch (error) {
      console.error('Erro ao salvar os itens:', error);
    } finally {
      // this.isLoading = false;
    }
  }

  formatarData(data: string): string {
    if (data) {
      const date1str = data.replace("Z", "");
      const dataObj = new Date(date1str)
      const dataFormatada = `${dataObj.toLocaleDateString('pt-BR')} ${dataObj.toLocaleTimeString('pt-BR')}`;
      return dataFormatada;
    } else {
      return 'sem data';
    }
  }

  convertToISOFormat(dateString: string): string | null {
    // Expressão regular para verificar o formato dd/MM/yyyy HH:mm:ss
    const dateTimeRegex = /^\d{2}\/\d{2}\/\d{4} \d{2}:\d{2}:\d{2}$/;
    if (!dateString.match(dateTimeRegex)) {
      return null; // Retorna null se a string não estiver no formato esperado
    }
    // Extrai os componentes da data e hora da string
    const [datePart, timePart] = dateString.split(' ');
    const [day, month, year] = datePart.split('/').map(Number);
    const [hours, minutes, seconds] = timePart.split(':').map(Number);
    // Cria um objeto Date com os componentes extraídos (mês é zero-indexado)
    const dateObject = new Date(Date.UTC(year, month - 1, day, hours, minutes, seconds));
    // Converte para formato ISO 8601
    const isoString = dateObject.toISOString();
    return isoString;
  }

  centerDialog(): void {
    const dialogRefElement = this.dialogRef?.containerInstance?.hostElement;
    if (dialogRefElement) {
      const windowWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
      const windowHeight = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
      const dialogWidth = dialogRefElement.clientWidth;
      const dialogHeight = dialogRefElement.clientHeight;
      const top = Math.max(0, (windowHeight - dialogHeight) / 2);
      const left = Math.max(0, (windowWidth - dialogWidth) / 2);
      dialogRefElement.style.top = `${top}px`;
      dialogRefElement.style.left = `${left}px`;
    }
  }

  isValidDate(dateStr: string) {
    const date = new Date(dateStr);
    return !isNaN(date.getTime());
  }

  async getItemsContainer(): Promise<void> {
    const today = new Date();
    // this.referenceDate = this.convertTimestampToFormattedDate(Date.now());
    this.referenceDate = this.convertTimestampToFormattedDate(this.dataExibir.getTime());
    try {
      const response: any = await new Promise(async (resolve, reject) => {
        (await this.dynamodbService.getItemsVolumesAltos("items_Excel_Container", this.urlConsultaCompactada, 'All', "Janela", this.referenceDate, this.numDays5)).subscribe(
          (res: any) => resolve(res),
          (error: any) => reject(error)
        );
      });
      if (response.statusCode == 200) {
        try {
          // //console.log(response.body)
          const items = JSON.parse(response.body);
          // console.log(items)
          if (Array.isArray(items)) {
            this.itemsContainersPrev = items
            this.itemsContainersPrev.forEach(item => {
              let dataString = item["Janela"] ? item["Janela"] : (item["Destino 1"] && item["Destino 1"].toUpperCase().includes('LCB')) ? item["JanelaDestino 1"] : (item["Destino 2"] && item["Destino 2"].toUpperCase().includes('LCB')) ? item["JanelaDestino 2"] :
                (item["Destino 3"] && item["Destino 3"].toUpperCase().includes('LCB')) ? item["JanelaDestino 3"] : null;
              item.dataJanelaOriginal = dataString.slice(0, 10); // "2024-04-23"
              item.horaJanelaOriginal = dataString.slice(11, 16); // "00:00"  
            })
            this.itemsContainers = this.filtrarItens(this.itemsContainersPrev);
            // console.log( this.itemsContainers)
            this.itemsContainers.forEach(async item => {
              item.Volumes = item.Volumes ? item.Volumes : item.quantidadeMU
              // item.Plate = item.plate 
              item.Fornecedores = item.terminalOrigem
              item.Transportadora = item.transportador
              item.idContainer = item.idContainer
              try {
                let dataString = item.dataAlteradaLCB ? `${item.dataAlteradaLCB}T${item.horaAlteradaLCB}:00.000Z` : item["Janela"] ? item["Janela"] :
                  (item["Destino 1"] && item["Destino 1"].toUpperCase().includes('LCB')) ? item["JanelaDestino 1"] :
                    (item["Destino 2"] && item["Destino 2"].toUpperCase().includes('LCB')) ? item["JanelaDestino 2"] :
                      (item["Destino 3"] && item["Destino 3"].toUpperCase().includes('LCB')) ? item["JanelaDestino 3"] : null;
                item.dataJanelaTimeTable = dataString.slice(0, 10); // "2024-04-23"
                item.horaJanelaTimeTable = dataString.slice(11, 16); // "00:00"  
              } catch {
                console.log("com erro")
                console.log(item)
              }
            });
            this.itemsContainersReuse = this.itemsContainers
              .filter(item => item.destinoApos?.includes("REUTILIZAR LCB"))
              .map(item => {
                return {
                  item,
                  ID: item.ID + "Reuse",
                  area: "EXP",
                };
              });

          } else {
            console.error('Invalid items data:', items);
          }
        } catch (error) {
          console.error('Error parsing JSON:', error);
        }
      } else {
        console.error('Invalid response:', response);
      }
    } catch (error) {
      console.error(error);
    }
  }

  formatarDataChegada(data: string): string {
    // Verifica se a data está no primeiro formato (MM/DD/YYYY HH:mm:ss AM/PM)
    if (/^\d{1,2}\/\d{1,2}\/\d{4} \d{1,2}:\d{2}:\d{2} (AM|PM)$/.test(data)) {
      // Separa os componentes da data
      const partes = data.split(/[\s/:]/);
      // Converte para o formato desejado (DD/MM/YYYY HH:mm:ss)
      const novaData = `${partes[1]}/${partes[0]}/${partes[2]} ${partes[3]}:${partes[4]}:${partes[5]}`;
      return novaData;
    }
    // Se estiver no segundo formato ou em outro formato, retorna a data original
    return data;
  }

  converterStringParaData(dataString: string): Date | null {
    dataString = this.formatarDataChegada(dataString);
    // Divide a string de data em partes separadas
    const partes = dataString.split(/[\/\s:]/);
    // Verifica se há 6 partes (ano, mês, dia, hora, minuto, segundo)
    if (partes.length === 6) {
      // Obtém os componentes individuais da data
      const ano = parseInt(partes[2], 10);
      const mes = parseInt(partes[1], 10) - 1; // Os meses em JavaScript são baseados em zero (janeiro é 0)
      const dia = parseInt(partes[0], 10);
      const hora = parseInt(partes[3], 10);
      const minuto = parseInt(partes[4], 10);
      const segundo = parseInt(partes[5], 10);
      // Cria um objeto Date com os componentes da data
      const data = new Date(ano, mes, dia, hora, minuto, segundo);
      return data;
    } else {
      // Se o formato da string de data não estiver correto, retorne null
      return null;
    }
  }

  async getItemsFromDynamoDB(): Promise<void> {
    const today = new Date();
    this.referenceDate = this.convertTimestampToFormattedDate(this.dataExibir.getTime());
    try {
      const response: any = await new Promise(async (resolve, reject) => {
        (await this.dynamodbService.getItemsVolumesAltos(this.query, this.urlConsultaCompactada, 'All', this.filterColumn, this.referenceDate, this.numDays5)).subscribe(
          (res: any) => resolve(res),
          (error: any) => reject(error)
        );
      });
      if (response.statusCode == 200) {
        try {
          const items = JSON.parse(response.body);
          if (Array.isArray(items)) {
            this.items = items;
            this.totalItensJetta = this.filtrarItens(this.items);
            this.totalItensJetta.forEach(async item => {
              // if (item["Transport Type"] === "BI-TREM") {
              //   item.Volumes = item.Volumes / 2;
              // }
              item.overflow = false;
              item.Fornecedores = [
                item['Fornecedor 1'],
                item['Fornecedor 2'],
                item['Fornecedor 3'],
                item['Fornecedor 4']
              ].filter(f => !!f && f.trim() !== '').join(', ')

              item.dataAlteradaLCB = item.dataAlteradaLCB ? item.dataAlteradaLCB : item.dataJanelaDestino1Alterada && (item["Destino 1"] && item["Destino 1"].toUpperCase().includes('LCB')) ?
                item.dataJanelaDestino1Alterada : item.dataJanelaDestino2Alterada && (item["Destino 2"] && item["Destino 2"].toUpperCase().includes('LCB')) ? item.dataJanelaDestino2Alterada :
                  item.dataJanelaDestino3Alterada && (item["Destino 3"] && item["Destino 3"].toUpperCase().includes('LCB')) ? item.dataJanelaDestino3Alterada : null;
              item.horaAlteradaLCB = item.horaAlteradaLCB ? item.horaAlteradaLCB : item.horaJanelaDestino1Alterada && (item["Destino 1"] && item["Destino 1"].toUpperCase().includes('LCB')) ?
                item.horaJanelaDestino1Alterada : item.horaJanelaDestino2Alterada && (item["Destino 2"] && item["Destino 2"].toUpperCase().includes('LCB')) ? item.horaJanelaDestino2Alterada :
                  item.horaJanelaDestino3Alterada && (item["Destino 3"] && item["Destino 3"].toUpperCase().includes('LCB')) ? item.horaJanelaDestino3Alterada : null;

              let dataString = (item["Destino 1"] && item["Destino 1"].toUpperCase().includes('LCB')) ? item["JanelaDestino 1"] ? item["JanelaDestino 1"] : item["JanelaDestino1Alterada"] : (item["Destino 2"] && item["Destino 2"].toUpperCase().includes('LCB')) ? item["JanelaDestino 2"] ? item["JanelaDestino 2"] : item["JanelaDestino2Alterada"] :
                (item["Destino 3"] && item["Destino 3"].toUpperCase().includes('LCB')) ? item["JanelaDestino 3"] ? item["JanelaDestino 3"] : item["JanelaDestino3Alterada"] : (item["destino"] && item["destino"].toUpperCase().includes('LCB')) ? item["Janela"] : new Date().toDateString();
              try {
                item.dataJanelaOriginal = dataString.slice(0, 10); // "2024-04-23"
                item.horaJanelaOriginal = dataString.slice(11, 16); // "00:00"  
              } catch {
                console.log("com erro", item);
              }
              dataString = item.dataAlteradaLCB ? `${item.dataAlteradaLCB}T${item.horaAlteradaLCB}:00.000` : dataString;
              try {
                item.dataJanelaTimeTable = dataString.slice(0, 10); // "2024-04-23"
                item.horaJanelaTimeTable = dataString.slice(11, 16); // "00:00"  
              } catch {
                console.log("com erro");
              }
            })
            this.cdr.detectChanges();
          } else {
            console.error('Invalid items data:', items);
          }
        } catch (error) {
          console.error('Error parsing JSON:', error);
        }
      } else {
        console.error('Invalid response:', response);
      }
    } catch (error) {
      console.error(error);
    }
  }

  async getItemsFromJanelasReservadas(): Promise<void> {
    const today = new Date();
    this.referenceDate = this.convertTimestampToFormattedDate(this.dataExibir.getTime());
    try {
      const response: any = await new Promise(async (resolve, reject) => {
        (await this.dynamodbService.getItemsVolumesAltos("janelasTimeTable", this.urlConsultaCompactada, 'All', "dataJanela", this.referenceDate, this.numDays)).subscribe(
          (res: any) => resolve(res),
          (error: any) => reject(error)
        );
      });
      if (response.statusCode == 200) {
        try {
          // //console.log(response.body)
          const items = JSON.parse(response.body);
          if (Array.isArray(items)) {
            // console.log(items)
            this.itemsReserva = items
            this.itemsReserva.forEach(item => {

              item.Fornecedores = item.Fornecedores ? item.Fornecedores : [
                item['Fornecedor 1'],
                item['Fornecedor 2'],
                item['Fornecedor 3'],
                item['Fornecedor 4']
              ].filter(f => !!f && f.trim() !== '').join(', ')
              if (!item.dataJanelaOriginal) {
                item.dataJanelaOriginal = item.dataJanela; // "2024-04-23"
                item.horaJanelaOriginal = item.horaJanela; // "00:00"  
              }
              if (!item.dataJanelaTimeTable) {
                item.dataJanelaTimeTable = item.dataAlteradaLCB ? item.dataAlteradaLCB : item.dataJanela;
              }
              if (!item.horaJanelaTimeTable) {
                item.horaJanelaTimeTable = item.horaAlteradaLCB ? item.horaAlteradaLCB : item.horaJanela;
              }
            })
            this.totalReservas = this.filtrarItens(this.itemsReserva);
            this.totalReservasRECCONT = []
            this.totalReservasRECCONT = this.totalReservas.filter(item => {
              return (item.area == 'RECCONT');
            })
            this.totalReservasRECSIDER = []
            this.totalReservasRECSIDER = this.totalReservas.filter(item => {
              return (item.area == 'RECSIDER');
            })
            this.totalReservasEMB = []
            this.totalReservasEMB = this.totalReservas.filter(item => {
              return (item.area == 'EMB');
            })
            this.totalReservasEMBMR = []
            this.totalReservasEMBMR = this.totalReservas.filter(item => {
              return (item.area == 'EMBMR');
            })
            this.totalReservasEXP = []
            this.totalReservasEXP = this.totalReservas.filter(item => {
              return (item.area == 'EXP');
            })
            this.cdr.detectChanges();
          } else {
            console.error('Invalid items data:', items);
          }
        } catch (error) {
          console.error('Error parsing JSON:', error);
        }
      } else {
        console.error('Invalid response:', response);
      }
    } catch (error) {
      console.error(error);
    }
  }

  async getItemsFromDiretasExtraLCB(): Promise<void> {
    const today = new Date();
    this.referenceDate = this.convertTimestampToFormattedDate(this.dataExibir.getTime());
    try {
      const response: any = await new Promise(async (resolve, reject) => {
        (await this.dynamodbService.getItemsVolumesAltos("Viagens-LCB-Diretas-Extras", this.urlConsultaCompactada, 'All', "dataSolicitacao", this.referenceDate, this.numDays)).subscribe(
          (res: any) => resolve(res),
          (error: any) => reject(error)
        );
      });
      if (response.statusCode == 200) {
        try {
          // //console.log(response.body)
          const items = JSON.parse(response.body);
          if (Array.isArray(items)) {
            // console.log(items)
            this.ViagensLCBDiretasExtras = items
            this.ViagensLCBDiretasExtras.forEach(item => {
              if (item.ID == "68653d30e374cf001ac08a481EMBMR") {
                console.log("esta na Viagens-LCB-Diretas-Extras")
              }
            })
          } else {
            console.error('Invalid items data:', items);
          }
        } catch (error) {
          console.error('Error parsing JSON:', error);
        }
      } else {
        console.error('Invalid response:', response);
      }
    } catch (error) {
      console.error(error);
    }
  }

  compararDatas(data1: string, data2: string) {
    const dataFormatada1 = new Date(data1).toLocaleDateString();
    const dataFormatada2 = new Date(data2).toLocaleDateString();
    return dataFormatada1 === dataFormatada2;
  }

  compararSubstrings(string1: string, string2: string, comprimentoMinimo: number) {
    const substrings1 = string1.toLowerCase().split(/\s+/); // Divida por espaços
    const substrings2 = string2.toLowerCase().split(/\s+/); // Divida por espaços

    // Filtra substrings com menos de comprimentoMinimo caracteres
    const substringsFiltradas1 = substrings1.filter(substring => substring.length > comprimentoMinimo);
    const substringsFiltradas2 = substrings2.filter(substring => substring.length > comprimentoMinimo);

    // Verifica se há alguma substring comum
    const temSubstringsComuns = substringsFiltradas1.some(substring1 =>
      substringsFiltradas2.some(substring2 => substring1.includes(substring2) || substring2.includes(substring1))
    );
    return temSubstringsComuns;
  }

  filtrarItens(itens: any[]): any[] {
    const vistos = new Set();
    this.dataExibir.setHours(0, 0, 0, 0); // Zera a hora para comparação
    return itens.filter(item => {
      try {
        // Verifica se já foi incluído pelo ID
        if (vistos.has(item.ID)) return false;
        // Verifica se é destino LCB
        const destinoLCB = ['Destino 1', 'Destino 2', 'Destino 3', 'destino', 'Fornecedor 1'].some(campo =>
          item[campo]?.toUpperCase().includes('LCB')
        );
        if (!destinoLCB) return false;
        // Define a dataHoraString com prioridade nos campos mais confiáveis
        let dataHoraString =
          item.dataAlteradaLCB && item.horaAlteradaLCB ? `${item.dataAlteradaLCB}T${item.horaAlteradaLCB}:00.000` :
            item.dataJanelaDestino1Alterada && (item["Destino 1"] && item["Destino 1"].toUpperCase().includes('LCB')) ? `${item.dataJanelaDestino1Alterada}T${item.horaJanelaDestino1Alterada}:00.000` :
              item.dataJanelaDestino2Alterada && (item["Destino 2"] && item["Destino 2"].toUpperCase().includes('LCB')) ? `${item.dataJanelaDestino2Alterada}T${item.horaJanelaDestino2Alterada}:00.000` :
                item.dataJanelaDestino3Alterada && (item["Destino 3"] && item["Destino 3"].toUpperCase().includes('LCB')) ? `${item.dataJanelaDestino3Alterada}T${item.horaJanelaDestino3Alterada}:00.000` :
                  item.dataJanelaTimeTable ? `${item.dataJanelaTimeTable}T${item.horaJanelaTimeTable}:00.000` :
                    item.dataJanela && item.horaJanela ? `${item.dataJanela}T${item.horaJanela}:00.000` :
                      item.dataJanela && item.horario ? `${item.dataJanela}T${item.horario}:00.000` :
                        item['JanelaDestino 1']?.replace("Z", "") && (item["Destino 1"] && item["Destino 1"].toUpperCase().includes('LCB')) ? item['JanelaDestino 1']?.replace("Z", "") :
                          item['JanelaDestino 2']?.replace("Z", "") && (item["Destino 2"] && item["Destino 2"].toUpperCase().includes('LCB')) ? item['JanelaDestino 2']?.replace("Z", "") :
                            item['JanelaDestino 3']?.replace("Z", "") && (item["Destino 3"] && item["Destino 3"].toUpperCase().includes('LCB')) ? item['JanelaDestino 3']?.replace("Z", "") :
                              item['Janela']?.replace("Z", "");
        const dataJanelaDestino = new Date(dataHoraString);
        dataJanelaDestino.setHours(0, 0, 0, 0);
        const mesmoDia = dataJanelaDestino.getTime() === this.dataExibir.getTime();
        if (mesmoDia) {
          vistos.add(item.ID); // Marca como já visto
          return true;
        }
        return false;
      } catch (err) {
        console.warn("Erro no filtro de item:", item, err);
        return false;
      }
    });
  }


  async compareDatesSemHoras(date1str: string, date2str: string): Promise<number> {
    if (date1str !== undefined) {
      try {
        date1str = date1str.replace("Z", "");
      } catch {
        // console.log(date1str)
      }
    }
    const date1 = this.removeTimeFromDate(new Date(date1str));
    const date2 = this.removeTimeFromDate(new Date(date2str));
    const timestamp1 = date1.getTime();
    const timestamp2 = date2.getTime();
    if (timestamp1 < timestamp2) {
      return -1; // date1 é anterior a date2
    } else if (timestamp1 > timestamp2) {
      return 1; // date1 é posterior a date2
    } else {
      return 0; // date1 é igual a date2
    }
  }

  removeTimeFromDate(date: Date): Date {
    date.setHours(0, 0, 0, 0);
    return date;
  }

  parseDateString(dateStr: string) {
    if (!dateStr.includes("T")) {
      dateStr += "T00:00:00";
    }
    return new Date(dateStr);
  }

  convertTimestampToFormattedDate(timestamp: number): string {
    // Converta para segundos dividindo por 1000
    const timestampSeconds = timestamp / 1000;
    // Crie um objeto Date
    const date = new Date(timestampSeconds * 1000); // Multiplique por 1000 para obter milissegundos
    // Formate a data no formato desejado
    const formattedDate = date.toLocaleDateString('pt-BR', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      hour12: false // Use formato de 24 horas
    }).replace(',', ''); // Remova a vírgula
    return formattedDate;
  }

  async getProgramacaoInterplantasFromDynamoDB(): Promise<void> {
    this.totalJanelasInterplantasObj = 0;
    const currentDate = new Date();
    this.referenceDate = this.convertTimestampToFormattedDate(this.dataExibir.getTime());
    try {
      const response: any = await new Promise(async (resolve, reject) => {
        (await this.dynamodbService.getItemsVolumesAltos(this.queryInterplantas, this.urlConsultaCompactada, 'All', this.filterColumn, this.referenceDate, 2)).subscribe(
          (res: any) => resolve(res),
          (error: any) => reject(error)
        );
      });
      if (response.statusCode == 200) {
        try {
          // //console.log(response.body)
          const items = JSON.parse(response.body);
          // console.log(items)
          if (Array.isArray(items)) {
            this.viagensInterplantasFinalizadas = [];
            this.itemsInterplantas = items
            this.itemsInterplantas = this.filtrarItens(this.itemsInterplantas);
            this.itemsInterplantas.forEach(async item => {
              item['JanelaDestino 1'] = item['Janela'];
              let dataString = item['JanelaDestino 1'];
              try {
                item.dataJanelaOriginal = dataString.slice(0, 10); // "2024-04-23"
                item.horaJanelaOriginal = dataString.slice(11, 16); // "00:00"  
                if (!item.dataJanelaTimeTable) {
                  item.dataJanelaTimeTable = item.dataAlteradaLCB ? item.dataAlteradaLCB : dataString.slice(0, 10);;
                }
                if (!item.horaJanelaTimeTable) {
                  item.horaJanelaTimeTable = item.horaAlteradaLCB ? item.horaAlteradaLCB : dataString.slice(11, 16);
                }
              } catch {
                console.log("com erro")
              }
            })
            this.viagensInterplantasFinalizadas = await items
              .filter(item =>
                item["Janela"] >= this.dataFiltraInterplantas && item.JanelaConcluida > 0)
          } else {
            console.error('Invalid items data:', items);
          }
        } catch (error) {
          console.error('Error parsing JSON:', error);
        }
      } else {
        console.error('Invalid response:', response);
      }
    } catch (error) {
      console.error(error);
    }
  }

  async getItemsFromArgentina(maxRetries: number = 3): Promise<void> {
    const today = new Date();
    this.referenceDate = this.convertTimestampToFormattedDate(this.dataExibir.getTime());
    for (let attempt = 1; attempt <= maxRetries; attempt++) {
      try {
        const response: any = await new Promise(async (resolve, reject) => {
          (await this.dynamodbService.getItemsVolumesAltos(this.query4, this.urlConsultaCompactada, 'All', this.filterColumn, this.referenceDate, this.numDays15)).subscribe(
            (res: any) => resolve(res),
            (error: any) => reject(error)
          );
        });
        if (response.statusCode === 200) {
          try {
            const items = JSON.parse(response.body);
            if (Array.isArray(items)) {
              this.argentina = items;
              // console.log(this.argentina);
              this.itemsArg = this.filtrarItens(this.argentina);
              // console.log(this.itemsArg)
              this.itemsArg.forEach(async item => {
                let dataString = (item["Destino 1"] && item["Destino 1"].toUpperCase().includes('LCB')) ? item["JanelaDestino 1"] : (item["Destino 2"] && item["Destino 2"].toUpperCase().includes('LCB')) ? item["JanelaDestino 2"] :
                  (item["Destino 3"] && item["Destino 3"].toUpperCase().includes('LCB')) ? item["JanelaDestino 3"] : (item["destino"] && item["destino"].toUpperCase().includes('LCB')) ? item["Janela"] :
                    (item["Janela 1"] && item["Fornecedor 1"].toUpperCase().includes('LCB')) ? item["Janela 1"] : (item["Janela 2"] && item["Fornecedor 2"].toUpperCase().includes('LCB')) ? item["Janela 2"] :
                      (item["Janela 3"] && item["Fornecedor 3"].toUpperCase().includes('LCB')) ? item["Janela 3"] : "";

                item.Fornecedores = [
                  item['Fornecedor 1'],
                  item['Fornecedor 2'],
                  item['Fornecedor 3'],
                  item['Fornecedor 4']
                ].filter(f => !!f && f.trim() !== '').join(', ')
                try {
                  item.dataJanelaOriginal = dataString.slice(0, 10); // "2024-04-23"
                  item.horaJanelaOriginal = dataString.slice(11, 16); // "00:00"  
                  if (!item.dataJanelaTimeTable) {
                    item.dataJanelaTimeTable = item.dataAlteradaLCB ? item.dataAlteradaLCB : dataString.slice(0, 10);
                  }
                  if (!item.horaJanelaTimeTable) {
                    item.horaJanelaTimeTable = item.horaAlteradaLCB ? item.horaAlteradaLCB : dataString.slice(11, 16);
                  }
                } catch {
                  console.log(item)
                  console.log("com erro")
                }
              })
              return; // Saia da função se bem-sucedido
            } else {
              console.error('Invalid items data:', items);
            }
          } catch (error) {
            console.error('Error parsing JSON:', error);
          }
        } else {
          console.error('Invalid response:', response);
        }
      } catch (error) {
        console.error(`Attempt ${attempt} failed:`, error);
      }
      if (attempt < maxRetries) {
        // console.log(`Retrying... (${attempt}/${maxRetries})`);
      }
    }
    console.error('All attempts to fetch items from Argentina failed.');
  }

  async getItemsFromVW(): Promise<void> {
    const today = new Date();
    try {
      const response: any = await new Promise(async (resolve, reject) => {
        (await this.dynamodbService.getItemsVolumesAltos(this.queryVW, this.urlConsultaCompactada, 'All', this.filterColumn, this.referenceDate, 2)).subscribe(
          (res: any) => resolve(res),
          (error: any) => reject(error)
        );
      });
      if (response.statusCode == 200) {
        try {
          const items = JSON.parse(response.body);
          if (Array.isArray(items)) {
            const auxItemsVW = items
            auxItemsVW.forEach(item => {
              if (item.ID == "68653d30e374cf001ac08a481EMBMR") {
                console.log("esta na " + this.queryVW)
              }
            })
            this.itemsVW = this.filtrarItens(auxItemsVW);
            this.itemsVW.forEach(async item => {
              let dataString = (item["Destino 1"] && item["Destino 1"].toUpperCase().includes('LCB')) ? item["JanelaDestino 1"] : (item["Destino 2"] && item["Destino 2"].toUpperCase().includes('LCB')) ? item["JanelaDestino 2"] :
                (item["Destino 3"] && item["Destino 3"].toUpperCase().includes('LCB')) ? item["JanelaDestino 3"] : (item["destino"] && item["destino"].toUpperCase().includes('LCB')) ? item["Janela"] : new Date().toDateString();
              item.Fornecedores = [
                item['Fornecedor 1'],
                item['Fornecedor 2'],
                item['Fornecedor 3'],
                item['Fornecedor 4']
              ].filter(f => !!f && f.trim() !== '').join(', ')

              try {
                item.dataJanelaOriginal = dataString.slice(0, 10); // "2024-04-23"
                item.horaJanelaOriginal = dataString.slice(11, 16); // "00:00"  
                if (!item.dataJanelaTimeTable) {
                  item.dataJanelaTimeTable = item.dataAlteradaLCB ? item.dataAlteradaLCB : dataString.slice(0, 10);
                }
                if (!item.horaJanelaTimeTable) {
                  item.horaJanelaTimeTable = item.horaAlteradaLCB ? item.horaAlteradaLCB : dataString.slice(11, 16);
                }
              } catch {
                console.log("com erro")
              }
            })
          } else {
            console.error('Invalid items data:', items);
          }
        } catch (error) {
          console.error('Error parsing JSON:', error);
        }
      } else {
        console.error('Invalid response:', response);
      }
    } catch (error) {
      console.error(error);
    }
  }

  async getCarriersFromDynamoDB(): Promise<void> {
    const filtro = '';
    (await this.dynamodbService.getItems(this.query2, this.urlConsulta, filtro)).subscribe(
      (response: any) => {
        if (response.statusCode == 200) {
          try {
            const items = JSON.parse(response.body);
            if (Array.isArray(items)) {
              this.carrier = items.map(item => ({ ...item, checked: false }));
              // Adiciona a chave 'checked' a cada item, com valor inicial como false
              // Forçar detecção de alterações após atualizar os dados
              this.cdr.detectChanges();
            } else {
              console.error('Invalid items data:', items);
            }
          } catch (error) {
            console.error('Error parsing JSON:', error);
          }
        } else {
          console.error('Invalid response:', response);
        }
      },
      (error: any) => {
        console.error(error);
      }
    );
  }

  async deleteItemTabelaExtraLCB(item: any): Promise<void> {
    // const confirmacao = window.confirm("Tem certeza que deseja excluir este registro?");
    let tableSalvar = '';
    // if (confirmacao) {
    this.isLoading = true;
    if (item.origemExtraLCB) {
      await this.dynamodbService.deleteItem(item.ID, this.urlAtualiza, this.queryDiretasExtrasLCB).subscribe(
        async response => {
          console.log("Deletado da tabela: " + tableSalvar)
        },
        error => {
          // Lógica para lidar com erros durante a deleção do item
        }
      );
    } else if (item.origemDiretoLCB) {
      await this.resetaValoresDiretosLCB(item);
    }
    // }
  }

  async resetaValoresDiretosLCB(item: any) {
    this.isLoading = true;
    this.item.tableName = this.queryDiretasLCB;
    this.item = {
      ...item,
      "lastUpdate": new Date(),
      "placa": "",
      "quantidadeMU": '0'
    }
    try {
      await this.dynamodbService.salvar([this.item], this.queryDiretasLCB, this.urlAtualiza).subscribe(async response => {
      }, error => {
        console.log(error);
      });
    } catch (error) {
      console.log(error);
    }
    // }
  }

  async deleteItem(Item: any): Promise<void> {
    const companyUsuarioLogado = this.usuarioLogado.company?.toLowerCase();
    const transportadoraItem = Item.Transportadora?.toLowerCase();
    if (this.usuarioLogado.role == '2' || this.usuarioLogado.role == '9' || (this.usuarioLogado.role == '3' && transportadoraItem.includes(companyUsuarioLogado) && (Item.area == "EMB" || Item.area == "EMBMR"))) {
      const confirmacao = window.confirm("Tem certeza que deseja excluir esta viagem?");
      // Verifica se o usuário confirmou a ação
      if (confirmacao) {
        this.isLoading = true;
        const ID = Item.ID;
        await this.dynamodbService.deleteItem(ID, this.urlAtualiza, Item.tableName).subscribe(
          async response => {
            if (Item.origemExtraLCB || Item.origemDiretoLCB) {
              await this.deleteItemTabelaExtraLCB(Item);
            }
            await this.ngOnInit();
            this.dialogOpen = false;
            this.isLoading = false;
          },
          error => {
            // Lógica para lidar com erros durante a deleção do item
          }
        );
      }
    } else {
      const confirmacao = window.confirm("Usuário não autorizado!");
      // Verifica se o usuário confirmou a ação
      if (confirmacao) {
        this.dialogOpen = false;
      }
    }
  }

  async FinalizarViagem(item: any) {
    const confirmacao = window.confirm("Tem certeza que deseja finalizar esta viagem?");
    let propertyName = "";
    // Verifica se o usuário confirmou a ação
    if (confirmacao) {
      this.isLoading = true;
      //console.log(item)
      var PassoF: any = []
      var PassoD: any = []
      for (let i = 1; i < 5; i++) {
        if (item['Fornecedor ' + i]) {
          PassoF[i] = 1;
        } else {
          PassoF[i] = 0;
        }
        // //console.log('PassoF[' + i + '] = ' + PassoF[i])
      }
      for (let i = 1; i < 5; i++) {
        if (item['Destino ' + i]) {
          PassoD[i] = 1;
        } else {
          PassoD[i] = 0;
        }
        // //console.log('PassoD[' + i + '] = ' + PassoD[i])
      }

      if (item['Destino 1'] && item['Destino 1'].toUpperCase().includes('LCB')) {
        propertyName = "FinalizacaoManualDestino1";
      } else if (item['Destino 2'] && item['Destino 2'].toUpperCase().includes('LCB')) {
        propertyName = "FinalizacaoManualDestino2";
      };

      const body = [{
        ...item, // Mantém as chaves existentes
        "ID": item.ID,
        "FinalizadaManual": true,
        [propertyName]: true,
        'Passo Fornecedor1': PassoF[1],
        'Passo Fornecedor2': PassoF[2],
        'Passo Fornecedor3': PassoF[3],
        'Passo Fornecedor4': PassoF[4],
        'Passo Destino1': PassoD[1],
        'Passo Destino2': PassoD[2],
        'Passo Destino3': PassoD[3],
        'Passo Destino4': PassoD[4],
      }];

      //nao usa a query, ele manda a time table no item
      await this.dynamodbService.salvar(body, item.tableName, this.urlAtualiza).subscribe(async response => {
        // Atualiza o item no banco de dados com sucesso
        await this.update();
        this.dialogOpen = false;
        this.isLoading = false;
      }, error => {
        console.log(error);
        // Lidar com o erro ao atualizar o item no banco de dados
      });
    }
  }

  async limparTabela() {
    console.log('clicou')
    const apiUrl = this.urlLimpaTabelaPrevisao; // URL do API Gateway
    // Corpo da requisição (os parâmetros esperados pelo Lambda)
    const body = {
      table_name: this.tabelaPrevisao,
      data: new Date(this.dataExibir).toISOString().split('T')[0] // opcional — envia a data de hoje no formato YYYY-MM-DD
    };
    console.log(body)
    this.dynamodbService.limparTabela(apiUrl, body).subscribe({
      next: response => {
        console.log('✅ Tabela limpa com sucesso:', response);
      },
      error: error => {
        console.error('❌ Erro ao limpar tabela:', error);
      }
    });
  }

  // async limparTabela() {
  //   const apiUrl = this.urlLimpaTabelaPrevisao; // URL completa do API Gateway
  //   this.dynamodbService.limparTabela(apiUrl).subscribe({
  //     next: response => {
  //       // console.log('✅ Tabela limpa com sucesso:', response);
  //     },
  //     error: error => {
  //       console.error('❌ Erro ao limpar tabela:', error);
  //     }
  //   });
  // }

  sortBy(column: string) {
    if (this.sortColumn === column) {
      // Reverse the sort direction
      this.sortDirection *= -1;
    } else {
      // Set the new sort column and reset the sort direction
      this.sortColumn = column;
      this.sortDirection = 1;
    }
    this.mergedData.sort((a: { [x: string]: any; }, b: { [x: string]: any; }) => {
      const valueA = a[this.sortColumn];
      const valueB = b[this.sortColumn];
      if (valueA < valueB) {
        return -1 * this.sortDirection;
      } else if (valueA > valueB) {
        return 1 * this.sortDirection;
      } else {
        return 0;
      }
    });
  }

  cancel(): void {
    this.edit2 = false;
    this.dialogOpen = false;
    this.dialogOpenSlots = false;
    this.dialogOpenVolumes = false;
  }

  async getUserLogado() {
    this.usuarioLogado = await this.servicoAutenticacao.obterUsuarioLogado()
    await this.enableFields();
    await this.enableFieldsTCM();
    await this.enableFieldsLOTS();
    await this.enableFieldsJSL();
    await this.enableFieldsJSLARG();
    await this.enableFieldsJSLVW();
    // console.log(this.usuarioLogado)
  }

  navigateTo(route: string): void {
    this.router.navigateByUrl(route);
  }

  removeDuplicados(array1: any[], array2: any[]) {
    // Cria conjuntos dos IDs dos arrays
    const ids1 = new Set(array1.map(item => item.ID));
    const ids2 = new Set(array2.map(item => item.ID));
    // Encontra IDs duplicados
    const duplicados = new Set([...ids1].filter(id => ids2.has(id)));
    // console.log(duplicados)
    const arrayFiltrado = array1.filter(item => !duplicados.has(item.ID));
    // console.log(arrayFiltrado)
    return arrayFiltrado;
  }

  async exportToExcel(data: any[], area: string): Promise<void> {
    var columnOrder: any[] = [];
    console.log(data);
    if (data.length === 0) {
      //console.log('Nenhum dado para exportar.');
      return;
    }
    if (this.usuarioLogado.role == '2' || this.usuarioLogado.role == '9') {
      columnOrder = [
        'ID',
        'Plate',
        'Transport Type',
        'Transportadora',
        'Fornecedores',
        'Volumes',
        'Registro',
        'Destino entrega',
        'Data janela entrega Original',
        'Hora janela entrega Original',
        'Data janela entrega Alterada',
        'Hora janela entrega Alterada',
        'Motivo da Alteração',
        'Data janela Realocada Auto',
        'Hora janela Realocada Auto',
        'data Chegada',
        'hora Chegada',
        'data Entrada',
        'hora Entrada',
        'data Saida',
        'hora Saida',
        'statusChegada',
        'FinalizadaManual',
      ];
    } else {
      columnOrder = [
        'ID',
        'Plate',
        'Transport Type',
        'Transportadora',
        'Fornecedores',
        'Volumes',
        'Registro',
        'Destino entrega',
        'Data janela entrega Original',
        'Hora janela entrega Original',
        'Data janela entrega Alterada',
        'Hora janela entrega Alterada',
        'Motivo da Alteração',
        'Data janela Realocada Auto',
        'Hora janela Realocada Auto',
        'data Chegada',
        'hora Chegada',
        'data Entrada',
        'hora Entrada',
        'data Saida',
        'hora Saida',
        'statusChegada'
      ];
    }
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet('Sheet1');
    // Adicione o cabeçalho à planilha e aplique formatação
    const headerRow = worksheet.addRow(columnOrder);
    headerRow.font = { bold: true };
    headerRow.fill = {
      type: 'pattern',
      pattern: 'solid',
      fgColor: { argb: 'C0C0C0' }
    };

    // Adicione bordas ao cabeçalho
    headerRow.border = {
      top: { style: 'thin' },
      left: { style: 'thin' },
      bottom: { style: 'thin' },
      right: { style: 'thin' }
    };
    for (const hora of data) {
      if (hora[area] && Array.isArray(hora[area])) {
        for (const item of hora[area]) {
          if (item['idContainer'] && item['idContainer'] != "") {
            const dataHoraString = item['Janela'] ? item['Janela'] : item['Destino 1'] && item['Destino 1'].includes('LCB') ? item['JanelaDestino 1'] :
              item['Destino 2'] && item['Destino 2'].includes('LCB') ? item['JanelaDestino 2'] :
                item['Destino 3'] && item['Destino 3'].includes('LCB') ? item['JanelaDestino 3'] : null
            try {
              if (!item['dataJanelaTimeTable']) {
                item['dataJanelaTimeTable'] = item.dataAlteradaLCB ? item.dataAlteradaLCB : dataHoraString.slice(0, 10);
              }
              if (!item['horaJanelaTimeTable']) {
                item['horaJanelaTimeTable'] = item.horaAlteradaLCB ? item.horaAlteradaLCB : dataHoraString.slice(11, 16);
              }
            } catch {
              console.log('Erro na data')
              console.log(item)
            }
            item['Destino entrega'] = item['Destino 1']
            item['Data janela entrega Original'] = item['dataJanelaOriginal']
            item['Hora janela entrega Original'] = item['horaJanelaOriginal']
            item['Data janela entrega Alterada'] = item['dataAlteradaLCB']
            item['Hora janela entrega Alterada'] = item['horaAlteradaLCB']
          }
          else if (item['dataJanelaTimeTable'] && item['horaJanelaTimeTable'] && item['Destino 1'].includes('LCB')) {
            try {
              item['dataJanelaTimeTable'] = item['dataJanelaTimeTable']; // "2024-04-23"
              item['horaJanelaTimeTable'] = item['horaJanelaTimeTable']; // "00:00"
              item['Destino entrega'] = item['Destino 1']
              // item['Data janela entrega'] = item['dataJanelaDestino1']
              // item['Hora janela entrega'] = item['horaJanelaDestino1']
              item['Data janela entrega Original'] = item['dataJanelaOriginal']
              item['Hora janela entrega Original'] = item['horaJanelaOriginal']
              item['Data janela entrega Alterada'] = item['dataJanelaDestino1Alterada']
              item['Hora janela entrega Alterada'] = item['horaJanelaDestino1Alterada']
            } catch {
              console.log(item)
              console.log(item['JanelaDestino 1'])
            }
          }
          else if (!item['dataJanelaDestino1'] && item['Destino 1'] && item['Destino 1'].includes('LCB')) {
            const dataHoraString = item['JanelaDestino 1'];
            try {
              item['dataJanelaTimeTable'] = dataHoraString ? dataHoraString.slice(0, 10) : ''; // "2024-04-23"
              item['horaJanelaTimeTable'] = dataHoraString ? dataHoraString.slice(11, 16) : ''; // "00:00"
              item['Destino entrega'] = item['Destino 1']
              item['Data janela entrega Original'] = item['dataJanelaOriginal']
              item['Hora janela entrega Original'] = item['horaJanelaOriginal']
              item['Data janela entrega Alterada'] = item['dataJanelaDestino1Alterada']
              item['Hora janela entrega Alterada'] = item['horaJanelaDestino1Alterada']
            } catch {
              console.log(item)
              console.log(item['JanelaDestino 1'])
            }
          } else if (!item['dataJanelaDestino2'] && item['Destino 2'] && item['Destino 2'].includes('LCB')) {
            const dataHoraString = item['JanelaDestino 2'];
            item['dataJanelaDestino2'] = dataHoraString ? dataHoraString.slice(0, 10) : ''; // "2024-04-23"
            item['horaJanelaDestino2'] = dataHoraString ? dataHoraString.slice(11, 16) : ''; // "00:00"
            item['Destino entrega'] = item['Destino 2']
            item['Data janela entrega Original'] = item['dataJanelaOriginal']
            item['Hora janela entrega Original'] = item['horaJanelaOriginal']
            item['Data janela entrega Alterada'] = item['dataJanelaDestino2Alterada']
            item['Hora janela entrega Alterada'] = item['horaJanelaDestino2Alterada']
          }
          else {
            if (item['Destino 1'] && item['Destino 1'].includes('LCB')) {
              item['Destino entrega'] = item['Destino 1']
              item['Data janela entrega Original'] = item['dataJanelaOriginal']
              item['Hora janela entrega Original'] = item['horaJanelaOriginal']
              item['Data janela entrega Alterada'] = item['dataJanelaDestino1Alterada']
              item['Hora janela entrega Alterada'] = item['horaJanelaDestino1Alterada']
            } else if (item['Destino 2'] && item['Destino 2'].includes('LCB')) {
              item['Destino entrega'] = item['Destino 2']
              item['Data janela entrega Original'] = item['dataJanelaOriginal']
              item['Hora janela entrega Original'] = item['horaJanelaOriginal']
              item['Data janela entrega Alterada'] = item['dataJanelaDestino2Alterada']
              item['Hora janela entrega Alterada'] = item['horaJanelaDestino2Alterada']
            } else if (item['Destino 3'] && item['Destino 3'].includes('LCB')) {
              item['Destino entrega'] = item['Destino 3']
              item['Data janela entrega Original'] = item['dataJanelaOriginal']
              item['Hora janela entrega Original'] = item['horaJanelaOriginal']
              item['Data janela entrega Alterada'] = item['dataJanelaDestino2Alterada']
              item['Hora janela entrega Alterada'] = item['horaJanelaDestino2Alterada']
            }
          }
          if (item.motAlteracao && item.motAlteracao != 0) {
            item['Motivo da Alteração'] = this.opcoesMotivo.find(opcao => opcao.valor == item.motAlteracao)?.descricao;
          }
          if (item['horaSlot'] && item['horaSlot'] != "") {
            item['Data janela Realocada Auto'] = item['dataJanelaTimeTable'];
            item['Hora janela Realocada Auto'] = item['horaSlot'] + ':00'
          }
          if (item['ChegadaLCB'] && item['ChegadaLCB'] != "") {
            const chegadaString = item['ChegadaLCB'];
            item['data Chegada'] = chegadaString.slice(0, 10); // "2024-04-23"
            item['hora Chegada'] = chegadaString.slice(11, 16); // "00:00"
          }
          if (item['EntradaLCB'] && item['EntradaLCB'] != "") {
            const entradaString = item['EntradaLCB'];
            item['data Entrada'] = entradaString.slice(0, 10); // "2024-04-23"
            item['hora Entrada'] = entradaString.slice(11, 16); // "00:00"
          }
          if (item['SaidaLCB'] && item['SaidaLCB'] != "") {
            const saidaString = item['SaidaLCB'];
            item['data Saida'] = saidaString.slice(0, 10); // "2024-04-23"
            item['hora Saida'] = saidaString.slice(11, 16); // "00:00"
          }
          if (item['Volumes']) {
            const vol = item['Volumes'];
            item['Volumes'] = parseFloat(vol);
          }
          if (item['SequenciaLCB']) {
            const seq = item['SequenciaLCB'];
            item['Registro'] = parseFloat(seq);
          }
          const row = columnOrder.map(column => item[column]);
          const dataRow = worksheet.addRow(row);
          // Adicione bordas aos dados
          dataRow.border = {
            top: { style: 'thin' },
            left: { style: 'thin' },
            bottom: { style: 'thin' },
            right: { style: 'thin' }
          };
        };
      };
    }
    // Salve o arquivo modificado

    let outputFilePath = '';
    if (this.filtroacionado) {
      let parsedDate = parseISO(this.dataExibirPre.toString());
      const auxDate = format(parsedDate, "dd/MM/yyyy");
      outputFilePath = 'time_table' + area + auxDate + '.xlsx';
    } else {
      outputFilePath = 'time_table' + area + this.startDate + '.xlsx';
    }
    const buffer = await workbook.xlsx.writeBuffer();
    const blobData = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
    fs.saveAs(blobData, outputFilePath);

    // Exiba um alerta para o usuário baixar o arquivo
    alert('Clique para baixar o arquivo.');
  }

  enableFields() {
    if (this.usuarioLogado.role == '2' || this.usuarioLogado.role == '9') {
      this.isCarrierEnabled = false;
    }
  }

  enableFieldsADM() {
    if (this.usuarioLogado.role == '9') {
      this.ADMEnabled = false;
    }
  }

  enableFieldsTCM() {
    if (this.usuarioLogado.role == '2' || this.usuarioLogado.role == '9' || (this.usuarioLogado.role == '3' && this.usuarioLogado.company == "TCM")) {
      this.isCarrierTCMEnabled = false;
    }
  }

  enableFieldsJSL() {
    if (this.usuarioLogado.role == '2' || this.usuarioLogado.role == '9' || (this.usuarioLogado.role == '3' && this.usuarioLogado.company == "JSL")) {
      this.isCarrierJSLEnabled = false;
    }
  }

  enableFieldsJSLARG() {
    if (this.usuarioLogado.role == '2' || this.usuarioLogado.role == '9' || (this.usuarioLogado.role == '3' && this.usuarioLogado.company == "JSL-ARG")) {
      this.isCarrierJSLARGEnabled = false;
    }
  }

  enableFieldsLOTS() {
    if (this.usuarioLogado.role == '2' || this.usuarioLogado.role == '9' || (this.usuarioLogado.role == '3' && this.usuarioLogado.company == "LOTS")) {
      this.isCarrierLOTSEnabled = false;
    }
  }

  enableFieldsJSLVW() {
    if (this.usuarioLogado.role == '2' || this.usuarioLogado.role == '9' || (this.usuarioLogado.role == '3' && this.usuarioLogado.company == "JSL-VW")) {
      this.isCarrierJSLVWEnabled = false;
    }
  }


}


